(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var _memoize = require(3);
var wrapper = require(4);

function memoize(getKey) {
  return _memoize(wrapper, getKey);
}

module.exports = memoize;

});
},{"3":3,"4":4,"8":8}],2:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var _retry = require(5);
var wrapper = require(4);

function retry(times, interval, error) {
  return _retry(wrapper, times, interval, error);
}

module.exports = retry;

});
},{"4":4,"5":5,"8":8}],3:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var defaultLogger = require(7);
var keyGetter = require(138);

function memoizeDecorator(wrapper, getKey) {
  getKey = keyGetter(getKey || function () { return '_default'; });
  return wrapper(function (func) {
    var cache = {};
    return function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];
      var cacheKey = getKey.apply(context, args);
      args[args.length - 1] = function (err, dep) {
        if (!err && cacheKey !== null) {
          cache[cacheKey] = dep;
        }
        cb(err, dep);
      };
      if (cacheKey !== null && cacheKey in cache) {
        logger('memoize-hit', {key: cacheKey, result: cache[cacheKey]});
        return cb(null, cache[cacheKey]);
      }
      else {
        func.apply(context, args);
      }
    };
  });
}

module.exports = memoizeDecorator;

});
},{"138":138,"7":7,"8":8}],4:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var promisify = require(135);
var callbackify = require(6);

// it works for decorator(f) and decorator([f1, f2, f3 ...])

function promiseTranslator(decorator) {
  return function (f) { // f returns a promise
    var cb;
    if (Array.isArray(f)) {
      cb = f.map(callbackify);
    } else {
      cb = callbackify(f);
    }

    return promisify(decorator(cb));
  };
}

module.exports = promiseTranslator;

});
},{"135":135,"6":6,"8":8}],5:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var defaultLogger = require(7);

function retryDecorator(wrapper, times, interval, error) {
  var condition;
  times = times || Infinity;
  error = error || Error;
  interval = interval || 0;
  var intervalFunc = typeof interval === 'function' ?
    interval :
    function () { return interval; };

  if (error === Error || Error.isPrototypeOf(error)) {
    condition = function (err, dep) { return err instanceof error; };
  }
  else {
    condition = error;
  }

  return wrapper(function (func) {
    return function () {
      var counter = 0;
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];

      var retry = function () {
        if (counter++ && intervalFunc(counter) > 0) { // do not wait for counter === 0
          setTimeout(function () {
            func.apply(context, args);
          }, interval);
        }
        else {
          func.apply(context, args);
        }
      };

      args[args.length - 1] = function (err, dep) {
        if (condition(err, dep) && counter < times) {
          logger('retry', {
            times: counter,
            actualResult: {err: err, res: dep}
          });
          retry();
        }
        else {
          cb(err, dep);
        }
      };
      retry();
    };
  });
}

module.exports = retryDecorator;

});
},{"7":7,"8":8}],6:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
function isPromise(obj) {
  return typeof obj === 'object' && 'then' in obj;
}

function callbackify(func) {
  return function () {
    // get arguments
    var context = this;
    var args = Array.prototype.slice.call(arguments, 0, -1);
    var cb = arguments[arguments.length - 1];
    try {
      var output = func.apply(context, args);
    }
    catch (e) {
      return cb(e);
    }

    if (isPromise(output)) {
      output.then(function (res) { // onfulfilled
        cb(null, res);
      },
      function (error) { // onrejected
        cb(error);
      });
    }
    else {
      cb(null, output);
    }
  };
}

module.exports = callbackify;

});
},{"8":8}],7:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function () {
  if (typeof this === 'object' && '__log' in this) {
    return this.__log;
  }
  return function () {};
};

});
},{"8":8}],8:[function(require,module,exports){
(function (global){
(function (cb){
  var w;
  try {
    w = window;
  } catch (e) {
    w = global;
  }

  var queue = w._async_define_queue = '_async_define_queue' in w ? w._async_define_queue : [];
  var cached_dependencies = w._async_define_cached_dependencies = '_async_define_cached_dependencies' in w ? w._async_define_cached_dependencies : {};

  function getDepsArray(depNames) {
    var i,
      tmp, depNS, depProp,
      len = depNames.length,
      deps = [];

    for (i = 0; i < len; i++) {
      tmp = depNames[i].split('|');
      depNS = tmp[0];
      depProp = tmp[1];
      if (depNS in cached_dependencies){
        deps.push(depProp ? cached_dependencies[depNS][depProp] : cached_dependencies[depNS]);
      }
      else {
        return;
      }
    }
    return deps;
  }

  function runThroughQueue() {
    while (_runThroughQueue());
  }

  function _runThroughQueue() {
    var i = 0;
    var solvedDependency = false;
    while (i < queue.length){
      if (execute(queue[i])){
        if (queue[i].name){
          solvedDependency = true;
        }
        queue.splice(i, 1);
      }
      else {
        i++;
      }
    }
    return solvedDependency;
  }

  function execute (item){
    if (item.name in cached_dependencies) { // don't execute twice
      return true;
    }
    var deps = getDepsArray(item.depNames);
    var exp;
    if (deps){
      exp = item.func.apply(w, deps);
      if (item.name){
        cached_dependencies[item.name] = exp;
      }
      return true;
    }
    else {
      return;
    }
  }

  function wrapObj (o){
    if (typeof o === 'function'){
      return o;
    }
    else {
      return function (){
        return o;
      };
    }
  }

  function ad() {
    var item = {
        name:  typeof arguments[0] === 'string' ? arguments[0] : undefined,
        depNames: Array.isArray(arguments[0]) ? arguments[0] : Array.isArray(arguments[1]) ? arguments[1] : [],
        func: wrapObj(arguments[arguments.length - 1])
    };
    if (!execute(item)){
      queue.push(item);
    }
    else {
      if (item.name){
        runThroughQueue(); // executed straight away, try to resolve func that depends on this
      }
    }
  }
  cb.call(w, ad);
}(function (define) {
  if (typeof exports === 'object'){
  module.exports = define;
}
else{
  this.asyncDefine = define;
}

}));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],9:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(31), __esModule: true };
});
},{"31":31,"8":8}],10:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(32), __esModule: true };
});
},{"32":32,"8":8}],11:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(33), __esModule: true };
});
},{"33":33,"8":8}],12:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(34), __esModule: true };
});
},{"34":34,"8":8}],13:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(35), __esModule: true };
});
},{"35":35,"8":8}],14:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(36), __esModule: true };
});
},{"36":36,"8":8}],15:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(37), __esModule: true };
});
},{"37":37,"8":8}],16:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(38), __esModule: true };
});
},{"38":38,"8":8}],17:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(39), __esModule: true };
});
},{"39":39,"8":8}],18:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(40), __esModule: true };
});
},{"40":40,"8":8}],19:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(41), __esModule: true };
});
},{"41":41,"8":8}],20:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(42), __esModule: true };
});
},{"42":42,"8":8}],21:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});
},{"8":8}],22:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _defineProperty = require(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});
},{"14":14,"8":8}],23:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _defineProperty = require(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});
},{"14":14,"8":8}],24:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
});
},{"12":12,"8":8}],25:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require(17);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require(13);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});
},{"13":13,"17":17,"28":28,"8":8}],26:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});
},{"28":28,"8":8}],27:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _isIterable2 = require(10);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require(9);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
});
},{"10":10,"8":8,"9":9}],28:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _iterator = require(20);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require(19);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});
},{"19":19,"20":20,"8":8}],29:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(155);

});
},{"155":155,"8":8}],30:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){

});
},{"8":8}],31:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(130);
require(126);
module.exports = require(115);
});
},{"115":115,"126":126,"130":130,"8":8}],32:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(130);
require(126);
module.exports = require(116);
});
},{"116":116,"126":126,"130":130,"8":8}],33:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var core  = require(50)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};
});
},{"50":50,"8":8}],34:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(118);
module.exports = require(50).Object.assign;
});
},{"118":118,"50":50,"8":8}],35:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(119);
var $Object = require(50).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
});
},{"119":119,"50":50,"8":8}],36:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(120);
var $Object = require(50).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
});
},{"120":120,"50":50,"8":8}],37:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(121);
module.exports = require(50).Object.getPrototypeOf;
});
},{"121":121,"50":50,"8":8}],38:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(122);
module.exports = require(50).Object.keys;
});
},{"122":122,"50":50,"8":8}],39:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(123);
module.exports = require(50).Object.setPrototypeOf;
});
},{"123":123,"50":50,"8":8}],40:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(124);
require(126);
require(130);
require(125);
module.exports = require(50).Promise;
});
},{"124":124,"125":125,"126":126,"130":130,"50":50,"8":8}],41:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(127);
require(124);
require(128);
require(129);
module.exports = require(50).Symbol;
});
},{"124":124,"127":127,"128":128,"129":129,"50":50,"8":8}],42:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(126);
require(130);
module.exports = require(112).f('iterator');
});
},{"112":112,"126":126,"130":130,"8":8}],43:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
});
},{"8":8}],44:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(){ /* empty */ };
});
},{"8":8}],45:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
});
},{"8":8}],46:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var isObject = require(69);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
});
},{"69":69,"8":8}],47:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require(106)
  , toLength  = require(107)
  , toIndex   = require(104);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
});
},{"104":104,"106":106,"107":107,"8":8}],48:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require(49)
  , TAG = require(113)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
});
},{"113":113,"49":49,"8":8}],49:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
});
},{"8":8}],50:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
});
},{"8":8}],51:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// optional / simple context binding
var aFunction = require(43);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
});
},{"43":43,"8":8}],52:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
});
},{"8":8}],53:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// Thank's IE8 for his funny defineProperty
module.exports = !require(58)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
});
},{"58":58,"8":8}],54:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var isObject = require(69)
  , document = require(60).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
});
},{"60":60,"69":69,"8":8}],55:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
});
},{"8":8}],56:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// all enumerable object keys, includes symbols
var getKeys = require(90)
  , gOPS    = require(87)
  , pIE     = require(91);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
});
},{"8":8,"87":87,"90":90,"91":91}],57:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global    = require(60)
  , core      = require(50)
  , ctx       = require(51)
  , hide      = require(62)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
});
},{"50":50,"51":51,"60":60,"62":62,"8":8}],58:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
});
},{"8":8}],59:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ctx         = require(51)
  , call        = require(70)
  , isArrayIter = require(67)
  , anObject    = require(46)
  , toLength    = require(107)
  , getIterFn   = require(114)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
});
},{"107":107,"114":114,"46":46,"51":51,"67":67,"70":70,"8":8}],60:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
});
},{"8":8}],61:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
});
},{"8":8}],62:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var dP         = require(82)
  , createDesc = require(93);
module.exports = require(53) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
});
},{"53":53,"8":8,"82":82,"93":93}],63:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(60).document && document.documentElement;
});
},{"60":60,"8":8}],64:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = !require(53) && !require(58)(function(){
  return Object.defineProperty(require(54)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
});
},{"53":53,"54":54,"58":58,"8":8}],65:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
});
},{"8":8}],66:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require(49);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
});
},{"49":49,"8":8}],67:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// check on default Array iterator
var Iterators  = require(75)
  , ITERATOR   = require(113)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
});
},{"113":113,"75":75,"8":8}],68:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.2.2 IsArray(argument)
var cof = require(49);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
});
},{"49":49,"8":8}],69:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
});
},{"8":8}],70:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// call something on iterator step with safe closing on error
var anObject = require(46);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
});
},{"46":46,"8":8}],71:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var create         = require(81)
  , descriptor     = require(93)
  , setToStringTag = require(98)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require(62)(IteratorPrototype, require(113)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
});
},{"113":113,"62":62,"8":8,"81":81,"93":93,"98":98}],72:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var LIBRARY        = require(77)
  , $export        = require(57)
  , redefine       = require(95)
  , hide           = require(62)
  , has            = require(61)
  , Iterators      = require(75)
  , $iterCreate    = require(71)
  , setToStringTag = require(98)
  , getPrototypeOf = require(88)
  , ITERATOR       = require(113)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
});
},{"113":113,"57":57,"61":61,"62":62,"71":71,"75":75,"77":77,"8":8,"88":88,"95":95,"98":98}],73:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ITERATOR     = require(113)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
});
},{"113":113,"8":8}],74:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
});
},{"8":8}],75:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = {};
});
},{"8":8}],76:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var getKeys   = require(90)
  , toIObject = require(106);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
});
},{"106":106,"8":8,"90":90}],77:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = true;
});
},{"8":8}],78:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var META     = require(110)('meta')
  , isObject = require(69)
  , has      = require(61)
  , setDesc  = require(82).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require(58)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
});
},{"110":110,"58":58,"61":61,"69":69,"8":8,"82":82}],79:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global    = require(60)
  , macrotask = require(103).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require(49)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
});
},{"103":103,"49":49,"60":60,"8":8}],80:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require(90)
  , gOPS     = require(87)
  , pIE      = require(91)
  , toObject = require(108)
  , IObject  = require(66)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require(58)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
});
},{"108":108,"58":58,"66":66,"8":8,"87":87,"90":90,"91":91}],81:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require(46)
  , dPs         = require(83)
  , enumBugKeys = require(55)
  , IE_PROTO    = require(99)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require(54)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require(63).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

});
},{"46":46,"54":54,"55":55,"63":63,"8":8,"83":83,"99":99}],82:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var anObject       = require(46)
  , IE8_DOM_DEFINE = require(64)
  , toPrimitive    = require(109)
  , dP             = Object.defineProperty;

exports.f = require(53) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
});
},{"109":109,"46":46,"53":53,"64":64,"8":8}],83:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var dP       = require(82)
  , anObject = require(46)
  , getKeys  = require(90);

module.exports = require(53) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
});
},{"46":46,"53":53,"8":8,"82":82,"90":90}],84:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var pIE            = require(91)
  , createDesc     = require(93)
  , toIObject      = require(106)
  , toPrimitive    = require(109)
  , has            = require(61)
  , IE8_DOM_DEFINE = require(64)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require(53) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
});
},{"106":106,"109":109,"53":53,"61":61,"64":64,"8":8,"91":91,"93":93}],85:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require(106)
  , gOPN      = require(86).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

});
},{"106":106,"8":8,"86":86}],86:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require(89)
  , hiddenKeys = require(55).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
});
},{"55":55,"8":8,"89":89}],87:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = Object.getOwnPropertySymbols;
});
},{"8":8}],88:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require(61)
  , toObject    = require(108)
  , IE_PROTO    = require(99)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
});
},{"108":108,"61":61,"8":8,"99":99}],89:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var has          = require(61)
  , toIObject    = require(106)
  , arrayIndexOf = require(47)(false)
  , IE_PROTO     = require(99)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
});
},{"106":106,"47":47,"61":61,"8":8,"99":99}],90:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require(89)
  , enumBugKeys = require(55);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
});
},{"55":55,"8":8,"89":89}],91:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = {}.propertyIsEnumerable;
});
},{"8":8}],92:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// most Object methods by ES6 should accept primitives
var $export = require(57)
  , core    = require(50)
  , fails   = require(58);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
});
},{"50":50,"57":57,"58":58,"8":8}],93:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
});
},{"8":8}],94:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var hide = require(62);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};
});
},{"62":62,"8":8}],95:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(62);
});
},{"62":62,"8":8}],96:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require(69)
  , anObject = require(46);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require(51)(Function.call, require(84).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
});
},{"46":46,"51":51,"69":69,"8":8,"84":84}],97:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var global      = require(60)
  , core        = require(50)
  , dP          = require(82)
  , DESCRIPTORS = require(53)
  , SPECIES     = require(113)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
});
},{"113":113,"50":50,"53":53,"60":60,"8":8,"82":82}],98:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var def = require(82).f
  , has = require(61)
  , TAG = require(113)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
});
},{"113":113,"61":61,"8":8,"82":82}],99:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var shared = require(100)('keys')
  , uid    = require(110);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
});
},{"100":100,"110":110,"8":8}],100:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global = require(60)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
});
},{"60":60,"8":8}],101:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require(46)
  , aFunction = require(43)
  , SPECIES   = require(113)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
});
},{"113":113,"43":43,"46":46,"8":8}],102:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toInteger = require(105)
  , defined   = require(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
});
},{"105":105,"52":52,"8":8}],103:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ctx                = require(51)
  , invoke             = require(65)
  , html               = require(63)
  , cel                = require(54)
  , global             = require(60)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require(49)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
});
},{"49":49,"51":51,"54":54,"60":60,"63":63,"65":65,"8":8}],104:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toInteger = require(105)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
});
},{"105":105,"8":8}],105:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
});
},{"8":8}],106:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require(66)
  , defined = require(52);
module.exports = function(it){
  return IObject(defined(it));
};
});
},{"52":52,"66":66,"8":8}],107:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.15 ToLength
var toInteger = require(105)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
});
},{"105":105,"8":8}],108:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.13 ToObject(argument)
var defined = require(52);
module.exports = function(it){
  return Object(defined(it));
};
});
},{"52":52,"8":8}],109:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require(69);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
});
},{"69":69,"8":8}],110:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
});
},{"8":8}],111:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global         = require(60)
  , core           = require(50)
  , LIBRARY        = require(77)
  , wksExt         = require(112)
  , defineProperty = require(82).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
});
},{"112":112,"50":50,"60":60,"77":77,"8":8,"82":82}],112:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = require(113);
});
},{"113":113,"8":8}],113:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var store      = require(100)('wks')
  , uid        = require(110)
  , Symbol     = require(60).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
});
},{"100":100,"110":110,"60":60,"8":8}],114:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var classof   = require(48)
  , ITERATOR  = require(113)('iterator')
  , Iterators = require(75);
module.exports = require(50).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
});
},{"113":113,"48":48,"50":50,"75":75,"8":8}],115:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var anObject = require(46)
  , get      = require(114);
module.exports = require(50).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
});
},{"114":114,"46":46,"50":50,"8":8}],116:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var classof   = require(48)
  , ITERATOR  = require(113)('iterator')
  , Iterators = require(75);
module.exports = require(50).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};
});
},{"113":113,"48":48,"50":50,"75":75,"8":8}],117:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var addToUnscopables = require(44)
  , step             = require(74)
  , Iterators        = require(75)
  , toIObject        = require(106);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require(72)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
});
},{"106":106,"44":44,"72":72,"74":74,"75":75,"8":8}],118:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.3.1 Object.assign(target, source)
var $export = require(57);

$export($export.S + $export.F, 'Object', {assign: require(80)});
});
},{"57":57,"8":8,"80":80}],119:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var $export = require(57)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require(81)});
});
},{"57":57,"8":8,"81":81}],120:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var $export = require(57);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require(53), 'Object', {defineProperty: require(82).f});
});
},{"53":53,"57":57,"8":8,"82":82}],121:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require(108)
  , $getPrototypeOf = require(88);

require(92)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
});
},{"108":108,"8":8,"88":88,"92":92}],122:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.14 Object.keys(O)
var toObject = require(108)
  , $keys    = require(90);

require(92)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
});
},{"108":108,"8":8,"90":90,"92":92}],123:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require(57);
$export($export.S, 'Object', {setPrototypeOf: require(96).set});
});
},{"57":57,"8":8,"96":96}],124:[function(require,module,exports){
arguments[4][30][0].apply(exports,arguments)
},{"30":30,"8":8}],125:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var LIBRARY            = require(77)
  , global             = require(60)
  , ctx                = require(51)
  , classof            = require(48)
  , $export            = require(57)
  , isObject           = require(69)
  , aFunction          = require(43)
  , anInstance         = require(45)
  , forOf              = require(59)
  , speciesConstructor = require(101)
  , task               = require(103).set
  , microtask          = require(79)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require(113)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require(94)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require(98)($Promise, PROMISE);
require(97)(PROMISE);
Wrapper = require(50)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require(73)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
});
},{"101":101,"103":103,"113":113,"43":43,"45":45,"48":48,"50":50,"51":51,"57":57,"59":59,"60":60,"69":69,"73":73,"77":77,"79":79,"8":8,"94":94,"97":97,"98":98}],126:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var $at  = require(102)(true);

// 21.1.3.27 String.prototype[@@iterator]()
require(72)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
});
},{"102":102,"72":72,"8":8}],127:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
// ECMAScript 6 symbols shim
var global         = require(60)
  , has            = require(61)
  , DESCRIPTORS    = require(53)
  , $export        = require(57)
  , redefine       = require(95)
  , META           = require(78).KEY
  , $fails         = require(58)
  , shared         = require(100)
  , setToStringTag = require(98)
  , uid            = require(110)
  , wks            = require(113)
  , wksExt         = require(112)
  , wksDefine      = require(111)
  , keyOf          = require(76)
  , enumKeys       = require(56)
  , isArray        = require(68)
  , anObject       = require(46)
  , toIObject      = require(106)
  , toPrimitive    = require(109)
  , createDesc     = require(93)
  , _create        = require(81)
  , gOPNExt        = require(85)
  , $GOPD          = require(84)
  , $DP            = require(82)
  , $keys          = require(90)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require(86).f = gOPNExt.f = $getOwnPropertyNames;
  require(91).f  = $propertyIsEnumerable;
  require(87).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require(77)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require(62)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
});
},{"100":100,"106":106,"109":109,"110":110,"111":111,"112":112,"113":113,"46":46,"53":53,"56":56,"57":57,"58":58,"60":60,"61":61,"62":62,"68":68,"76":76,"77":77,"78":78,"8":8,"81":81,"82":82,"84":84,"85":85,"86":86,"87":87,"90":90,"91":91,"93":93,"95":95,"98":98}],128:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(111)('asyncIterator');
});
},{"111":111,"8":8}],129:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(111)('observable');
});
},{"111":111,"8":8}],130:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(117);
var global        = require(60)
  , hide          = require(62)
  , Iterators     = require(75)
  , TO_STRING_TAG = require(113)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
});
},{"113":113,"117":117,"60":60,"62":62,"75":75,"8":8}],131:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

'use strict';

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

});
},{"8":8}],132:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (typeof define == 'function' && define.amd)
  {
    define(function(){
      return nativePromiseSupported ? NativePromise : Promise;
    });
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"8":8}],133:[function(require,module,exports){
(function (process,global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

});
}).call(this,require(141),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"141":141,"8":8}],134:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*jslint es6, node, browser, maxlen: 120 */
/*global self, window */

"use strict";

module.exports = (function () {

    "use strict";

    var globalObject = undefined;

    function isFunction(x) {
        return typeof x === "function";
    }

    // Seek the global object
    if (global !== undefined) {
        globalObject = global;
    } else if (window !== undefined && window.document) {
        globalObject = window;
    } else {
        globalObject = self;
    }

    // Test for any native promise implementation, and if that
    // implementation appears to conform to the specificaton.
    // This code mostly nicked from the es6-promise module polyfill
    // and then fooled with.
    var hasPromiseSupport = (function () {

        // No promise object at all, and it's a non-starter
        if (!globalObject.hasOwnProperty("Promise")) {
            return false;
        }

        // There is a Promise object. Does it conform to the spec?
        var P = globalObject.Promise;

        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        if (!P.hasOwnProperty("resolve") || !P.hasOwnProperty("reject")) {
            return false;
        }

        if (!P.hasOwnProperty("all") || !P.hasOwnProperty("race")) {
            return false;
        }

        // Older version of the spec had a resolver object
        // as the arg rather than a function
        return (function () {

            var resolve = undefined,
                p = new globalObject.Promise(function (r) {
                resolve = r;
            });

            if (p) {
                return isFunction(resolve);
            }

            return false;
        })();
    })();

    // Export the native Promise implementation if it
    // looks like it matches the spec
    if (hasPromiseSupport) {
        return globalObject.Promise;
    }

    //  Otherwise, return the es6-promise polyfill by @jaffathecake.
    return require(133).Promise;
})();
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"133":133,"8":8}],135:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*jslint node, this, es6, maxlen: 120 */
"use strict";

module.exports = (function () {

    "use strict";

    // Get a promise object. This may be native, or it may be polyfilled
    var ES6Promise = require(134);

    // Promise Context object constructor.
    function Context(resolve, reject, custom) {
        this.resolve = resolve;
        this.reject = reject;
        this.custom = custom;
    }

    // Default callback function - rejects on truthy error, otherwise resolves
    function callback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var ctx = args.shift(),
            err = args.shift(),
            cust = undefined;

        args = args.length > 1 ? args : args[0];

        if (typeof ctx.custom === 'function') {
            cust = function () {
                for (var _len2 = arguments.length, custArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    custArgs[_key2] = arguments[_key2];
                }

                // Bind the callback to itself, so the resolve and reject
                // properties that we bound are available to the callback.
                // Then we push it onto the end of the arguments array.
                return ctx.custom.apply(cust, custArgs);
            };
            cust.resolve = ctx.resolve;
            cust.reject = ctx.reject;
            cust.call(null, err, args);
        } else {
            if (err) {
                return ctx.reject(err);
            }
            ctx.resolve(args);
        }
    }

    /**
     * promisify
     *
     * Transforms callback-based function -- func(arg1, arg2 .. argN, callback) -- into
     * an ES6-compatible Promise. User can provide their own callback function; otherwise
     * promisify provides a callback of the form (error, result) and rejects on truthy error.
     * If supplying your own callback function, use this.resolve() and this.reject().
     *
     * @param {function} original - The function to promisify
     * @param {function} callback - Optional custom callbac function
     *
     * @return {function} A promisified version of 'original'
     */
    return function (original, custom) {

        return function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            // Store original context
            var that = this;

            // Return the promisified function
            return new ES6Promise(function (resolve, reject) {

                // Create a Context object
                var ctx = new Context(resolve, reject, custom);

                // Append the callback bound to the context
                args.push(callback.bind(null, ctx));

                // Call the function
                original.apply(that, args);
            });
        };
    };
})();
});
},{"134":134,"8":8}],136:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
(function() {
	var testObject = {};

	if (!(Object.setPrototypeOf || testObject.__proto__)) {
		var nativeGetPrototypeOf = Object.getPrototypeOf;

		Object.getPrototypeOf = function(object) {
			if (object.__proto__) {
				return object.__proto__;
			} else {
				return nativeGetPrototypeOf.call(Object, object);
			}
		}
	}
})();

});
},{"8":8}],137:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

/**
 * Expose `md5omatic(str)`.
 */
 
module.exports = md5omatic;

/**
 * Hash any string using message digest.
 *
 * @param {String} str
 * @return {String}
 * @api public
 */
 
function md5omatic(str) {
    var x = str2blks_MD5(str);
    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;

    for(var i=0; i<x.length; i += 16)
    {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
        d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
        c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
        b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
        d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
        c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
        a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
        d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i+10], 17, -42063);
        b = ff(b, c, d, a, x[i+11], 22, -1990404162);
        a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
        d = ff(d, a, b, c, x[i+13], 12, -40341101);
        c = ff(c, d, a, b, x[i+14], 17, -1502002290);
        b = ff(b, c, d, a, x[i+15], 22,  1236535329);
        a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
        d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
        c = gg(c, d, a, b, x[i+11], 14,  643717713);
        b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
        a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
        d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
        c = gg(c, d, a, b, x[i+15], 14, -660478335);
        b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
        a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
        d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
        c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
        b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
        a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
        d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
        c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
        b = gg(b, c, d, a, x[i+12], 20, -1926607734);
        a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
        d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i+11], 16,  1839030562);
        b = hh(b, c, d, a, x[i+14], 23, -35309556);
        a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
        d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
        c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
        b = hh(b, c, d, a, x[i+10], 23, -1094730640);
        a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
        d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
        c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
        b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
        a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
        d = hh(d, a, b, c, x[i+12], 11, -421815835);
        c = hh(c, d, a, b, x[i+15], 16,  530742520);
        b = hh(b, c, d, a, x[i+ 2], 23, -995338651);
        a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
        d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
        c = ii(c, d, a, b, x[i+14], 15, -1416354905);
        b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
        a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
        d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i+10], 15, -1051523);
        b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
        d = ii(d, a, b, c, x[i+15], 10, -30611744);
        c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i+13], 21,  1309151649);
        a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
        d = ii(d, a, b, c, x[i+11], 10, -1120210379);
        c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
        b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

        a = addme(a, olda);
        b = addme(b, oldb);
        c = addme(c, oldc);
        d = addme(d, oldd);
    }

    return rhex(a) + rhex(b) + rhex(c) + rhex(d);
};

var hex_chr = "0123456789abcdef";

function bitOR(a, b)
{
    var lsb = (a & 0x1) | (b & 0x1);
    var msb31 = (a >>> 1) | (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitXOR(a, b)
{
    var lsb = (a & 0x1) ^ (b & 0x1);
    var msb31 = (a >>> 1) ^ (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitAND(a, b)
{
    var lsb = (a & 0x1) & (b & 0x1);
    var msb31 = (a >>> 1) & (b >>> 1);

    return (msb31 << 1) | lsb;
}

function addme(x, y)
{
    var lsw = (x & 0xFFFF)+(y & 0xFFFF);
    var msw = (x >> 16)+(y >> 16)+(lsw >> 16);

    return (msw << 16) | (lsw & 0xFFFF);
}

function rhex(num)
{
    var str = "";
    var j;

    for(j=0; j<=3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) + hex_chr.charAt((num >> (j * 8)) & 0x0F);

    return str;
}

function str2blks_MD5(str)
{
    var nblk = ((str.length + 8) >> 6) + 1;
    var blks = new Array(nblk * 16);
    var i;

    for(i=0; i<nblk * 16; i++)
        blks[i] = 0;

    for(i=0; i<str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << (((str.length * 8 + i) % 4) * 8);

    blks[i >> 2] |= 0x80 << (((str.length * 8 + i) % 4) * 8);

    var l = str.length * 8;
    blks[nblk * 16 - 2] = (l & 0xFF);
    blks[nblk * 16 - 2] |= ((l >>> 8) & 0xFF) << 8;
    blks[nblk * 16 - 2] |= ((l >>> 16) & 0xFF) << 16;
    blks[nblk * 16 - 2] |= ((l >>> 24) & 0xFF) << 24;

    return blks;
}

function rol(num, cnt)
{
    return (num << cnt) | (num >>> (32 - cnt));
}

function cmn(q, a, b, x, s, t)
{
    return addme(rol((addme(addme(a, q), addme(x, t))), s), b);
}

function ff(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, c), bitAND((~b), d)), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, d), bitAND(c, (~d))), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(bitXOR(b, c), d), a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(c, bitOR(b, (~d))), a, b, x, s, t);
}
});
},{"8":8}],138:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var md5omatic = require(137);

module.exports = function (func, prefix) {
  prefix = prefix || '';
  func = func || function () { return '_default'; };
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var k = func.apply(undefined, args);
    if (k === null) {
      return null;
    }
    if (typeof k === 'undefined' ||
      (typeof k === 'number' && isNaN(k)) ||
      k === '' ||
      (typeof k === 'object' && Object.keys(k).length === 0)) {
      throw new Error('Not a valid key');
    }
    if (typeof k !== 'string') {
      k = md5omatic(JSON.stringify(k));
    }
    return prefix + k;
  };
};

});
},{"137":137,"8":8}],139:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
function isObj(v) {
  return typeof v === 'object';
}

function isStr(v) {
  return typeof v === 'string';
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isUndef(v) {
  if (typeof v === 'string') {
    return v.length === 0;
  }
  return typeof v === 'undefined';
}

function flatten(arr) {
  return [].concat.apply([], arr);
}

var emailRE = /.+\@.+\..+/;

var _validatorFactories = {
  object: function () { return function (value) { return (isUndef(value) || isObj(value) ? [] : ['object.base']); }; },
  string: function () { return function (value) { return (isUndef(value) || isStr(value) ? [] : ['string.base']); }; },
  boolean: function () { return function (value) { return (isUndef(value) || isBool(value) ? [] : ['boolean.base']); }; },
  min: function (minValue) { return function (value) { return (isUndef(value) || value.length >= minValue ? [] : ['string.min']); }; },
  max: function (maxValue) { return function (value) { return (isUndef(value) || value.length <= maxValue ? [] : ['string.max']); }; },
  email: function () { return function (value) { return (isUndef(value) || emailRE.test(value) ? [] : ['string.email']); }; },
  required: function () { return function (value) { return (!isUndef(value) ? [] : ['any.empty']); }; },
  regex: function (re) { return function (value) { return (isUndef(value) || re.test(value) ? [] : ['string.regex.base']); }; },
  keys: function (obj) { return function (value) { return (isUndef(value) ? [] : flatten(Object.keys(obj).map(function (attr) { return obj[attr]._validate(value[attr], attr); }))); }; },
};

function _joi() {
  this._validators = [];
}

var joi = {};

Object.keys(_validatorFactories).forEach(function (k) {
  _joi.prototype[k] = function unnamed(arg) {
    this._validators.push(_validatorFactories[k](arg));
    return this;
  };

  joi[k] = function (arg) {
    var j = new _joi();
    return j[k](arg);
  };
});

_joi.prototype._validate = function _validate(value, path) {
  return flatten(this._validators.map(function (func) { return func(value); }))
  .map(function (e) {
    var out = {
      type: typeof e === 'string' ? e : e.type,
    };
    var paths = [];
    if (path) {
      paths.push(path);
    }
    if (typeof e !== 'string' && 'path' in e) {
      paths.push(e.path);
    }

    if (paths.length) {
      out.path = paths.join('.');
    }
    return out;
  });
};

joi.validate = function validate(data, schema, options, callback) {
  // const abortEarly = options.abortEarly;
  var errors = schema._validate(data);
  var out = errors.length ? {
    error: {
      details: errors,
    },
    value: data,
  } : { error: null, value: data };

  if (callback) {
    callback(out.error, out.value);
  }
  return out;
};

module.exports = joi;

});
},{"8":8}],140:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDate = undefined;

var _defineProperty2 = require(23);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectAll(node) {
  setTimeout(function () {
    node.setSelectionRange(0, node.value.length);
  }, 5);
}

function setFocus(node) {
  node.focus();
  selectAll(node);
}

function getDateItem(s) {
  // undefined and null should return an empty string (invalid date)
  var d = new Date(s || '');
  var inValid = isNaN(d.getDate());
  var day = inValid ? '' : d.getDate().toString();
  var month = inValid ? '' : (d.getMonth() + 1).toString();
  var year = inValid ? '' : d.getFullYear().toString();
  return { day: day, month: month, year: year };
}

function inputBuilder(context, name, placeholder, maxLength, label) {
  var controlName = context.props.name;
  var id = controlName + '-' + name;
  var description = label + ' - ' + name;
  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'label',
      { className: 'tes-simple-date__label', htmlFor: id },
      description
    ),
    _react2.default.createElement('input', {
      id: id,
      className: 'tes-simple-date__item tes-simple-date__' + name,
      onClick: function onClick(e) {
        return context.onClick(e);
      },
      onKeyDown: function onKeyDown(e) {
        return context.focusNext(e, name);
      },
      ref: name,
      onChange: function onChange(e) {
        return context.onChange(e, name, maxLength);
      },
      size: maxLength,
      value: context.state[name],
      placeholder: placeholder
    })
  );
}

var SimpleDate = exports.SimpleDate = function (_Component) {
  (0, _inherits3.default)(SimpleDate, _Component);

  function SimpleDate(props) {
    (0, _classCallCheck3.default)(this, SimpleDate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleDate.__proto__ || (0, _getPrototypeOf2.default)(SimpleDate)).call(this, props));

    _this.sequence = _this.props.sequence || ['day', 'month', 'year'];
    _this.nextItems = _this.sequence.reduce(function (obj, cur, index, arr) {
      obj[cur] = arr[index + 1];
      return obj;
    }, {});

    _this.previousItems = _this.sequence.reduce(function (obj, cur, index, arr) {
      obj[cur] = arr[index - 1];
      return obj;
    }, {});
    _this.state = getDateItem(_this.props.value);
    return _this;
  }

  (0, _createClass3.default)(SimpleDate, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _state = this.state,
          year = _state.year,
          month = _state.month,
          day = _state.day;

      if (prevState.day === day && prevState.month === month && prevState.year === year) {
        return;
      }
      this.props.onChange(year + '-' + month + '-' + day);
    }
  }, {
    key: 'onChange',
    value: function onChange(evt, current, maxLength) {
      var nextItem = this.nextItems[current];
      // const previousItem = this.previousItems[current];
      var currentValue = this.refs[current].value;

      if (new RegExp('^[0-9]{0,' + maxLength + '}$').test(currentValue)) {
        this.setState((0, _defineProperty3.default)({}, current, currentValue));
        if (nextItem && currentValue.length >= maxLength) {
          setFocus(this.refs[nextItem]);
        }
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      selectAll(evt.target);
    }
  }, {
    key: 'focusNext',
    value: function focusNext(evt, current) {
      var nextItem = this.nextItems[current];
      var previousItem = this.previousItems[current];
      var currentValue = this.refs[current].value;

      if (nextItem) {
        if (evt.key === '/' || evt.key === '-' || evt.key === 'ArrowRight' && evt.target.selectionStart === currentValue.length) {
          setFocus(this.refs[nextItem]);
        }
      }

      if (previousItem) {
        if (evt.key === 'ArrowLeft' && evt.target.selectionStart === 0) {
          setFocus(this.refs[previousItem]);
        } else if (currentValue.length === 0 && evt.key === 'Backspace') {
          setFocus(this.refs[previousItem]);
          evt.preventDefault();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var day = inputBuilder(this, 'day', 'DD', 2, this.props.label);
      var month = inputBuilder(this, 'month', 'MM', 2, this.props.label);
      var year = inputBuilder(this, 'year', 'YYYY', 4, this.props.label);

      var dateComponents = { day: day, month: month, year: year };
      var sequence = this.props.sequence || ['day', 'month', 'year'];

      return _react2.default.createElement(
        'div',
        { className: 'tes-simple-date' },
        _react2.default.createElement('input', { type: 'hidden', name: this.props.name, value: this.props.value }),
        dateComponents[sequence[0]],
        '/',
        dateComponents[sequence[1]],
        '/',
        dateComponents[sequence[2]]
      );
    }
  }]);
  return SimpleDate;
}(_react.Component);

SimpleDate.propTypes = {
  name: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  value: _react.PropTypes.string.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  sequence: _react.PropTypes.array
};

exports.default = SimpleDate;
});
},{"15":15,"21":21,"22":22,"23":23,"25":25,"26":26,"8":8}],141:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

});
},{"8":8}],142:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(143)
});
},{"143":143,"8":8}],143:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _io = require(148);

Object.defineProperty(exports, 'take', {
  enumerable: true,
  get: function get() {
    return _io.take;
  }
});
Object.defineProperty(exports, 'takem', {
  enumerable: true,
  get: function get() {
    return _io.takem;
  }
});
Object.defineProperty(exports, 'put', {
  enumerable: true,
  get: function get() {
    return _io.put;
  }
});
Object.defineProperty(exports, 'race', {
  enumerable: true,
  get: function get() {
    return _io.race;
  }
});
Object.defineProperty(exports, 'call', {
  enumerable: true,
  get: function get() {
    return _io.call;
  }
});
Object.defineProperty(exports, 'apply', {
  enumerable: true,
  get: function get() {
    return _io.apply;
  }
});
Object.defineProperty(exports, 'cps', {
  enumerable: true,
  get: function get() {
    return _io.cps;
  }
});
Object.defineProperty(exports, 'fork', {
  enumerable: true,
  get: function get() {
    return _io.fork;
  }
});
Object.defineProperty(exports, 'spawn', {
  enumerable: true,
  get: function get() {
    return _io.spawn;
  }
});
Object.defineProperty(exports, 'join', {
  enumerable: true,
  get: function get() {
    return _io.join;
  }
});
Object.defineProperty(exports, 'cancel', {
  enumerable: true,
  get: function get() {
    return _io.cancel;
  }
});
Object.defineProperty(exports, 'select', {
  enumerable: true,
  get: function get() {
    return _io.select;
  }
});
Object.defineProperty(exports, 'actionChannel', {
  enumerable: true,
  get: function get() {
    return _io.actionChannel;
  }
});
Object.defineProperty(exports, 'cancelled', {
  enumerable: true,
  get: function get() {
    return _io.cancelled;
  }
});
Object.defineProperty(exports, 'flush', {
  enumerable: true,
  get: function get() {
    return _io.flush;
  }
});
});
},{"148":148,"8":8}],144:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;

var _runSaga = require(151);

Object.defineProperty(exports, 'runSaga', {
  enumerable: true,
  get: function get() {
    return _runSaga.runSaga;
  }
});

var _channel = require(147);

Object.defineProperty(exports, 'END', {
  enumerable: true,
  get: function get() {
    return _channel.END;
  }
});
Object.defineProperty(exports, 'eventChannel', {
  enumerable: true,
  get: function get() {
    return _channel.eventChannel;
  }
});
Object.defineProperty(exports, 'channel', {
  enumerable: true,
  get: function get() {
    return _channel.channel;
  }
});

var _buffers = require(146);

Object.defineProperty(exports, 'buffers', {
  enumerable: true,
  get: function get() {
    return _buffers.buffers;
  }
});

var _sagaHelpers = require(152);

Object.defineProperty(exports, 'takeEvery', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeEvery;
  }
});
Object.defineProperty(exports, 'takeLatest', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeLatest;
  }
});
Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.throttle;
  }
});

var _utils = require(153);

Object.defineProperty(exports, 'delay', {
  enumerable: true,
  get: function get() {
    return _utils.delay;
  }
});
Object.defineProperty(exports, 'CANCEL', {
  enumerable: true,
  get: function get() {
    return _utils.CANCEL;
  }
});

var _middleware = require(149);

var _middleware2 = _interopRequireDefault(_middleware);

var _effects = require(143);

var effects = _interopRequireWildcard(_effects);

var _utils2 = require(154);

var utils = _interopRequireWildcard(_utils2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _middleware2.default;
exports.effects = effects;
exports.utils = utils;
});
},{"143":143,"146":146,"147":147,"149":149,"151":151,"152":152,"153":153,"154":154,"8":8}],145:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = asap;
var queue = [];
var isSuspended = false;

function asap(task) {
  if (!isSuspended) {
    isSuspended = true;
    queue.push(task);
    asap.flush();
  } else {
    queue.push(task);
  }
}

asap.suspend = function () {
  return isSuspended = true;
};
asap.flush = function () {
  var nextTask = void 0;
  while (nextTask = queue.shift()) {
    nextTask();
  }
  isSuspended = false;
};
});
},{"8":8}],146:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buffers = exports.BUFFER_OVERFLOW = undefined;

var _utils = require(153);

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length <= 0 || arguments[0] === undefined ? 10 : arguments[0];
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush
  };
}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};
});
},{"153":153,"8":8}],147:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.emitter = emitter;
exports.channel = channel;
exports.eventChannel = eventChannel;
exports.stdChannel = stdChannel;

var _utils = require(153);

var _buffers = require(146);

var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = exports.END = { type: CHANNEL_END_TYPE };
var isEnd = exports.isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return (0, _utils.remove)(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (process.env.NODE_ENV !== 'production') {
  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length <= 0 || arguments[0] === undefined ? _buffers.buffers.fixed() : arguments[0];

  var closed = false;
  var takers = [];

  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return (0, _utils.remove)(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return { take: take, put: put, flush: flush, close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length <= 1 || arguments[1] === undefined ? _buffers.buffers.none() : arguments[1];
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      chan.close();
    } else if (!matcher || matcher(input)) {
      chan.put(input);
    }
  });

  if (!_utils.is.func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: function close() {
      if (!chan.__closed__) {
        chan.close();
        unsubscribe();
      }
    }
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(subscribe);

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    }
  });
}
});
}).call(this,require(141))

},{"141":141,"146":146,"153":153,"8":8}],148:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEffect = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.take = take;
exports.takem = takem;
exports.put = put;
exports.race = race;
exports.call = call;
exports.apply = apply;
exports.cps = cps;
exports.fork = fork;
exports.spawn = spawn;
exports.join = join;
exports.cancel = cancel;
exports.select = select;
exports.actionChannel = actionChannel;
exports.cancelled = cancelled;
exports.flush = flush;

var _utils = require(153);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IO = (0, _utils.sym)('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
};

function take() {
  var patternOrChannel = arguments.length <= 0 || arguments[0] === undefined ? '*' : arguments[0];

  if (arguments.length) {
    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (_utils.is.pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (_utils.is.channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

function takem() {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
}

function put(channel, action) {
  if (arguments.length > 1) {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
  } else {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.sync = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].sync = true;
  return eff;
};

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (_utils.is.array(fn)) {
    var _fn = fn;

    var _fn2 = _slicedToArray(_fn, 2);

    context = _fn2[0];
    fn = _fn2[1];
  } else if (fn.fn) {
    var _fn3 = fn;
    context = _fn3.context;
    fn = _fn3.fn;
  }
  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

var isForkedTask = function isForkedTask(task) {
  return task[_utils.TASK];
};

function join(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(JOIN, task);
}

function cancel(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(CANCEL, task);
}

function select(selector) {
  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (arguments.length === 0) {
    selector = _utils.ident;
  } else {
    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

var asEffect = exports.asEffect = {
  take: function take(effect) {
    return effect && effect[IO] && effect[TAKE];
  },
  put: function put(effect) {
    return effect && effect[IO] && effect[PUT];
  },
  race: function race(effect) {
    return effect && effect[IO] && effect[RACE];
  },
  call: function call(effect) {
    return effect && effect[IO] && effect[CALL];
  },
  cps: function cps(effect) {
    return effect && effect[IO] && effect[CPS];
  },
  fork: function fork(effect) {
    return effect && effect[IO] && effect[FORK];
  },
  join: function join(effect) {
    return effect && effect[IO] && effect[JOIN];
  },
  cancel: function cancel(effect) {
    return effect && effect[IO] && effect[CANCEL];
  },
  select: function select(effect) {
    return effect && effect[IO] && effect[SELECT];
  },
  actionChannel: function actionChannel(effect) {
    return effect && effect[IO] && effect[ACTION_CHANNEL];
  },
  cancelled: function cancelled(effect) {
    return effect && effect[IO] && effect[CANCELLED];
  },
  flush: function flush(effect) {
    return effect && effect[IO] && effect[FLUSH];
  }
};
});
},{"153":153,"8":8}],149:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sagaMiddlewareFactory;

var _utils = require(153);

var _proc = require(150);

var _proc2 = _interopRequireDefault(_proc);

var _channel = require(147);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sagaMiddlewareFactory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var runSagaDynamically = void 0;

  if (_utils.is.func(options)) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (options.logger && !_utils.is.func(options.logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (options.onerror && !_utils.is.func(options.onerror)) {
    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref) {
    var getState = _ref.getState;
    var dispatch = _ref.dispatch;

    runSagaDynamically = runSaga;
    var sagaEmitter = (0, _channel.emitter)();

    function runSaga(saga) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options, 0, saga.name);
    }

    return function (next) {
      return function (action) {
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function (saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
    return runSagaDynamically.apply(undefined, [saga].concat(args));
  };

  return sagaMiddleware;
}
});
}).call(this,require(141))

},{"141":141,"147":147,"150":150,"153":153,"8":8}],150:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
exports.default = proc;

var _utils = require(153);

var _asap = require(145);

var _asap2 = _interopRequireDefault(_asap);

var _io = require(148);

var _channel = require(147);

var _buffers = require(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isDev = process.env.NODE_ENV === 'development';

var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var nextEffectId = (0, _utils.autoInc)();
var CHANNEL_END = exports.CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = exports.TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return _utils.kTrue;
  },
  default: function _default(pattern) {
    return function (input) {
      return input.type === pattern;
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return p === input.type;
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes iff all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0, _utils.remove)(tasks, task);
      task.cont = _utils.noop;
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = _utils.noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context;
  var fn = _ref.fn;
  var args = _ref.args;

  if (_utils.is.iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {
    throw error;
  }) : (0, _utils.makeIterator)(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

function wrapHelper(helper) {
  return {
    fn: helper
  };
}

function proc(iterator) {
  var subscribe = arguments.length <= 1 || arguments[1] === undefined ? function () {
    return _utils.noop;
  } : arguments[1];
  var dispatch = arguments.length <= 2 || arguments[2] === undefined ? _utils.noop : arguments[2];
  var getState = arguments.length <= 3 || arguments[3] === undefined ? _utils.noop : arguments[3];
  var options = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
  var parentEffectId = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];
  var name = arguments.length <= 6 || arguments[6] === undefined ? 'anonymous' : arguments[6];
  var cont = arguments[7];

  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);

  var sagaMonitor = options.sagaMonitor;
  var logger = options.logger;
  var onError = options.onError;

  var log = logger || _utils.log;
  var stdChannel = (0, _channel.stdChannel)(subscribe);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = _utils.noop;

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL autoamtically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          Thill will jump to the finally block
        **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (result === TASK_CANCEL && isDev) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
    var cb = arguments[3];

    var effectId = nextEffectId();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel;
    var pattern = _ref2.pattern;
    var maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel;
    var action = _ref3.action;
    var sync = _ref3.sync;

    /*
      Use a reentrant lock `asap` to flatten all nested dispatches
      If this put cause another Saga to take this action an then immediately
      put an action that will be taken by this Saga. Then the outer Saga will miss
      the action from the inner Saga b/c this put has not yet returned.
    */
    (0, _asap2.default)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.sync` was used then bubble up the error.
        if (channel || sync) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (sync && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context;
    var fn = _ref4.fn;
    var args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context;
    var fn = _ref5.fn;
    var args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      (function () {
        var cpsCb = function cpsCb(err, res) {
          return _utils.is.undef(err) ? cb(res) : cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) {
          cb.cancel = function () {
            return cpsCb.cancel();
          };
        }
      })();
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context;
    var fn = _ref6.fn;
    var args = _ref6.args;
    var detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    _asap2.default.suspend();
    var task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);

    if (detached) {
      cb(task);
    } else {
      if (taskIterator._isRunning) {
        taskQueue.addTask(task);
        cb(task);
      } else if (taskIterator._error) {
        taskQueue.abort(taskIterator._error);
      } else {
        cb(task);
      }
    }
    _asap2.default.flush();
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      (function () {
        var joiner = { task: task, cb: cb };
        cb.cancel = function () {
          return (0, _utils.remove)(t.joiners, joiner);
        };
        t.joiners.push(joiner);
      })();
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(task, cb) {
    if (task.isRunning()) {
      task.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runParallelEffect(effects, effectId, cb) {
    if (!effects.length) {
      return cb([]);
    }

    var completedCount = 0;
    var completed = void 0;
    var results = Array(effects.length);

    function checkEffectEnd() {
      if (completedCount === results.length) {
        completed = true;
        cb(results);
      }
    }

    var childCbs = effects.map(function (eff, idx) {
      var chCbAtIdx = function chCbAtIdx(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[idx] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtIdx.cancel = _utils.noop;
      return chCbAtIdx;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        childCbs.forEach(function (chCb) {
          return chCb.cancel();
        });
      }
    };

    effects.forEach(function (eff, idx) {
      return runEffect(eff, effectId, idx, childCbs[idx]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          cb.cancel();
          completed = true;
          cb(_defineProperty({}, key, res));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector;
    var args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern;
    var buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
      return iterator._isRunning;
    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
      return iterator._isCancelled;
    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
      return iterator._isAborted;
    }), _defineProperty(_ref9, 'result', function result() {
      return iterator._result;
    }), _defineProperty(_ref9, 'error', function error() {
      return iterator._error;
    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
});
}).call(this,require(141))

},{"141":141,"145":145,"146":146,"147":147,"148":148,"153":153,"8":8}],151:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = runSaga;

var _utils = require(153);

var _proc = require(150);

var _proc2 = _interopRequireDefault(_proc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runSaga(iterator, _ref) {
  var subscribe = _ref.subscribe;
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;
  var sagaMonitor = _ref.sagaMonitor;
  var logger = _ref.logger;


  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");

  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger });
}
});
},{"150":150,"153":153,"8":8}],152:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.takeEvery = takeEvery;
exports.takeLatest = takeLatest;
exports.throttle = throttle;

var _channel = require(147);

var _utils = require(153);

var _io = require(148);

var _buffers = require(146);

var done = { done: true, value: undefined };
var qEnd = {};

function fsmIterator(fsm, q0) {
  var name = arguments.length <= 2 || arguments[2] === undefined ? 'iterator' : arguments[2];

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext]();

      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);

      var q = _fsm$qNext2[0];
      var output = _fsm$qNext2[1];
      var _updateState = _fsm$qNext2[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return (0, _utils.makeIterator)(next, function (error) {
    return next(null, error);
  }, name, true);
}

function safeName(pattern) {
  if (Array.isArray(pattern)) {
    return String(pattern.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(pattern);
  }
}

function takeEvery(pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
}

function takeLatest(pattern, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: (0, _io.cancel)(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
}

function throttle(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel, pattern) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
});
},{"146":146,"147":147,"148":148,"153":153,"8":8}],153:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.check = check;
exports.remove = remove;
exports.deferred = deferred;
exports.arrayOfDeffered = arrayOfDeffered;
exports.delay = delay;
exports.createMockTask = createMockTask;
exports.autoInc = autoInc;
exports.makeIterator = makeIterator;
exports.log = log;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sym = exports.sym = function sym(id) {
  return '@@redux-saga/' + id;
};
var TASK = exports.TASK = sym('TASK');
var HELPER = exports.HELPER = sym('HELPER');
var MATCH = exports.MATCH = sym('MATCH');
var CANCEL = exports.CANCEL = sym('cancelPromise');
var konst = exports.konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = exports.kTrue = konst(true);
var kFalse = exports.kFalse = konst(false);
var noop = exports.noop = function noop() {};
var ident = exports.ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var is = exports.is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  array: Array.isArray,
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

function deferred() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
    return running;
  }), _defineProperty(_ref, 'result', function result() {
    return _result;
  }), _defineProperty(_ref, 'error', function error() {
    return _error;
  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
    return running = b;
  }), _defineProperty(_ref, 'setResult', function setResult(r) {
    return _result = r;
  }), _defineProperty(_ref, 'setError', function setError(e) {
    return _error = e;
  }), _ref;
}

function autoInc() {
  var seed = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

  return function () {
    return ++seed;
  };
}

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length <= 1 || arguments[1] === undefined ? kThrow : arguments[1];
  var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message, error) {
  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};
});
},{"8":8}],154:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require(153);

Object.defineProperty(exports, 'TASK', {
  enumerable: true,
  get: function get() {
    return _utils.TASK;
  }
});
Object.defineProperty(exports, 'noop', {
  enumerable: true,
  get: function get() {
    return _utils.noop;
  }
});
Object.defineProperty(exports, 'is', {
  enumerable: true,
  get: function get() {
    return _utils.is;
  }
});
Object.defineProperty(exports, 'deferred', {
  enumerable: true,
  get: function get() {
    return _utils.deferred;
  }
});
Object.defineProperty(exports, 'arrayOfDeffered', {
  enumerable: true,
  get: function get() {
    return _utils.arrayOfDeffered;
  }
});
Object.defineProperty(exports, 'createMockTask', {
  enumerable: true,
  get: function get() {
    return _utils.createMockTask;
  }
});

var _io = require(148);

Object.defineProperty(exports, 'asEffect', {
  enumerable: true,
  get: function get() {
    return _io.asEffect;
  }
});
});
},{"148":148,"153":153,"8":8}],155:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require(156);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"156":156,"8":8}],156:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"8":8}],157:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*!
  * Reqwest! A general purpose XHR connection manager
  * license MIT (c) Dustin Diaz 2015
  * https://github.com/ded/reqwest
  */

!function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else context[name] = definition()
}('reqwest', this, function () {

  var context = this

  if ('window' in context) {
    var doc = document
      , byTag = 'getElementsByTagName'
      , head = doc[byTag]('head')[0]
  } else {
    var XHR2
    try {
      XHR2 = require(30)
    } catch (ex) {
      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
    }
  }


  var httpsRe = /^http/
    , protocolRe = /(^\w+):\/\//
    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    , readyState = 'readyState'
    , contentType = 'Content-Type'
    , requestedWith = 'X-Requested-With'
    , uniqid = 0
    , callbackPrefix = 'reqwest_' + (+new Date())
    , lastValue // data stored by the most recent JSONP callback
    , xmlHttpRequest = 'XMLHttpRequest'
    , xDomainRequest = 'XDomainRequest'
    , noop = function () {}

    , isArray = typeof Array.isArray == 'function'
        ? Array.isArray
        : function (a) {
            return a instanceof Array
          }

    , defaultHeaders = {
          'contentType': 'application/x-www-form-urlencoded'
        , 'requestedWith': xmlHttpRequest
        , 'accept': {
              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
            , 'xml':  'application/xml, text/xml'
            , 'html': 'text/html'
            , 'text': 'text/plain'
            , 'json': 'application/json, text/javascript'
            , 'js':   'application/javascript, text/javascript'
          }
      }

    , xhr = function(o) {
        // is it x-domain
        if (o['crossOrigin'] === true) {
          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
          if (xhr && 'withCredentials' in xhr) {
            return xhr
          } else if (context[xDomainRequest]) {
            return new XDomainRequest()
          } else {
            throw new Error('Browser does not support cross-origin requests')
          }
        } else if (context[xmlHttpRequest]) {
          return new XMLHttpRequest()
        } else if (XHR2) {
          return new XHR2()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      }
    , globalSetupOptions = {
        dataFilter: function (data) {
          return data
        }
      }

  function succeed(r) {
    var protocol = protocolRe.exec(r.url)
    protocol = (protocol && protocol[1]) || context.location.protocol
    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
  }

  function handleReadyState(r, success, error) {
    return function () {
      // use _aborted to mitigate against IE err c00c023f
      // (can't read props on aborted request objects)
      if (r._aborted) return error(r.request)
      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
      if (r.request && r.request[readyState] == 4) {
        r.request.onreadystatechange = noop
        if (succeed(r)) success(r.request)
        else
          error(r.request)
      }
    }
  }

  function setHeaders(http, o) {
    var headers = o['headers'] || {}
      , h

    headers['Accept'] = headers['Accept']
      || defaultHeaders['accept'][o['type']]
      || defaultHeaders['accept']['*']

    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
    // breaks cross-origin requests with legacy browsers
    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
    for (h in headers)
      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
  }

  function setCredentials(http, o) {
    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
      http.withCredentials = !!o['withCredentials']
    }
  }

  function generalCallback(data) {
    lastValue = data
  }

  function urlappend (url, s) {
    return url + (/\?/.test(url) ? '&' : '?') + s
  }

  function handleJsonp(o, fn, err, url) {
    var reqId = uniqid++
      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
      , match = url.match(cbreg)
      , script = doc.createElement('script')
      , loaded = 0
      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1

    if (match) {
      if (match[3] === '?') {
        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
      } else {
        cbval = match[3] // provided callback func name
      }
    } else {
      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
    }

    context[cbval] = generalCallback

    script.type = 'text/javascript'
    script.src = url
    script.async = true
    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
      // need this for IE due to out-of-order onreadystatechange(), binding script
      // execution to an event listener gives us control over when the script
      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
      script.htmlFor = script.id = '_reqwest_' + reqId
    }

    script.onload = script.onreadystatechange = function () {
      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
        return false
      }
      script.onload = script.onreadystatechange = null
      script.onclick && script.onclick()
      // Call the user callback with the last value stored and clean up values and scripts.
      fn(lastValue)
      lastValue = undefined
      head.removeChild(script)
      loaded = 1
    }

    // Add the script to the DOM head
    head.appendChild(script)

    // Enable JSONP timeout
    return {
      abort: function () {
        script.onload = script.onreadystatechange = null
        err({}, 'Request is aborted: timeout', {})
        lastValue = undefined
        head.removeChild(script)
        loaded = 1
      }
    }
  }

  function getRequest(fn, err) {
    var o = this.o
      , method = (o['method'] || 'GET').toUpperCase()
      , url = typeof o === 'string' ? o : o['url']
      // convert non-string objects to query-string form unless o['processData'] is false
      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
        ? reqwest.toQueryString(o['data'])
        : (o['data'] || null)
      , http
      , sendWait = false

    // if we're working on a GET request and we have data then we should append
    // query string to end of URL and not post data
    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
      url = urlappend(url, data)
      data = null
    }

    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)

    // get the xhr from the factory if passed
    // if the factory returns null, fall-back to ours
    http = (o.xhr && o.xhr(o)) || xhr(o)

    http.open(method, url, o['async'] === false ? false : true)
    setHeaders(http, o)
    setCredentials(http, o)
    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
        http.onload = fn
        http.onerror = err
        // NOTE: see
        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
        http.onprogress = function() {}
        sendWait = true
    } else {
      http.onreadystatechange = handleReadyState(this, fn, err)
    }
    o['before'] && o['before'](http)
    if (sendWait) {
      setTimeout(function () {
        http.send(data)
      }, 200)
    } else {
      http.send(data)
    }
    return http
  }

  function Reqwest(o, fn) {
    this.o = o
    this.fn = fn

    init.apply(this, arguments)
  }

  function setType(header) {
    // json, javascript, text/plain, text/html, xml
    if (header === null) return undefined; //In case of no content-type.
    if (header.match('json')) return 'json'
    if (header.match('javascript')) return 'js'
    if (header.match('text')) return 'html'
    if (header.match('xml')) return 'xml'
  }

  function init(o, fn) {

    this.url = typeof o == 'string' ? o : o['url']
    this.timeout = null

    // whether request has been fulfilled for purpose
    // of tracking the Promises
    this._fulfilled = false
    // success handlers
    this._successHandler = function(){}
    this._fulfillmentHandlers = []
    // error handlers
    this._errorHandlers = []
    // complete (both success and fail) handlers
    this._completeHandlers = []
    this._erred = false
    this._responseArgs = {}

    var self = this

    fn = fn || function () {}

    if (o['timeout']) {
      this.timeout = setTimeout(function () {
        timedOut()
      }, o['timeout'])
    }

    if (o['success']) {
      this._successHandler = function () {
        o['success'].apply(o, arguments)
      }
    }

    if (o['error']) {
      this._errorHandlers.push(function () {
        o['error'].apply(o, arguments)
      })
    }

    if (o['complete']) {
      this._completeHandlers.push(function () {
        o['complete'].apply(o, arguments)
      })
    }

    function complete (resp) {
      o['timeout'] && clearTimeout(self.timeout)
      self.timeout = null
      while (self._completeHandlers.length > 0) {
        self._completeHandlers.shift()(resp)
      }
    }

    function success (resp) {
      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
      resp = (type !== 'jsonp') ? self.request : resp
      // use global data filter on response text
      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
        , r = filteredResponse
      try {
        resp.responseText = r
      } catch (e) {
        // can't assign this in IE<=8, just ignore
      }
      if (r) {
        switch (type) {
        case 'json':
          try {
            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
          } catch (err) {
            return error(resp, 'Could not parse JSON in response', err)
          }
          break
        case 'js':
          resp = eval(r)
          break
        case 'html':
          resp = r
          break
        case 'xml':
          resp = resp.responseXML
              && resp.responseXML.parseError // IE trololo
              && resp.responseXML.parseError.errorCode
              && resp.responseXML.parseError.reason
            ? null
            : resp.responseXML
          break
        }
      }

      self._responseArgs.resp = resp
      self._fulfilled = true
      fn(resp)
      self._successHandler(resp)
      while (self._fulfillmentHandlers.length > 0) {
        resp = self._fulfillmentHandlers.shift()(resp)
      }

      complete(resp)
    }

    function timedOut() {
      self._timedOut = true
      self.request.abort()
    }

    function error(resp, msg, t) {
      resp = self.request
      self._responseArgs.resp = resp
      self._responseArgs.msg = msg
      self._responseArgs.t = t
      self._erred = true
      while (self._errorHandlers.length > 0) {
        self._errorHandlers.shift()(resp, msg, t)
      }
      complete(resp)
    }

    this.request = getRequest.call(this, success, error)
  }

  Reqwest.prototype = {
    abort: function () {
      this._aborted = true
      this.request.abort()
    }

  , retry: function () {
      init.call(this, this.o, this.fn)
    }

    /**
     * Small deviation from the Promises A CommonJs specification
     * http://wiki.commonjs.org/wiki/Promises/A
     */

    /**
     * `then` will execute upon successful requests
     */
  , then: function (success, fail) {
      success = success || function () {}
      fail = fail || function () {}
      if (this._fulfilled) {
        this._responseArgs.resp = success(this._responseArgs.resp)
      } else if (this._erred) {
        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._fulfillmentHandlers.push(success)
        this._errorHandlers.push(fail)
      }
      return this
    }

    /**
     * `always` will execute whether the request succeeds or fails
     */
  , always: function (fn) {
      if (this._fulfilled || this._erred) {
        fn(this._responseArgs.resp)
      } else {
        this._completeHandlers.push(fn)
      }
      return this
    }

    /**
     * `fail` will execute when the request fails
     */
  , fail: function (fn) {
      if (this._erred) {
        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._errorHandlers.push(fn)
      }
      return this
    }
  , 'catch': function (fn) {
      return this.fail(fn)
    }
  }

  function reqwest(o, fn) {
    return new Reqwest(o, fn)
  }

  // normalize newline variants according to spec -> CRLF
  function normalize(s) {
    return s ? s.replace(/\r?\n/g, '\r\n') : ''
  }

  function serial(el, cb) {
    var n = el.name
      , t = el.tagName.toLowerCase()
      , optCb = function (o) {
          // IE gives value="" even where there is no value attribute
          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
          if (o && !o['disabled'])
            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
        }
      , ch, ra, val, i

    // don't serialize elements that are disabled or without a name
    if (el.disabled || !n) return

    switch (t) {
    case 'input':
      if (!/reset|button|image|file/i.test(el.type)) {
        ch = /checkbox/i.test(el.type)
        ra = /radio/i.test(el.type)
        val = el.value
        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
      }
      break
    case 'textarea':
      cb(n, normalize(el.value))
      break
    case 'select':
      if (el.type.toLowerCase() === 'select-one') {
        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
      } else {
        for (i = 0; el.length && i < el.length; i++) {
          el.options[i].selected && optCb(el.options[i])
        }
      }
      break
    }
  }

  // collect up all form elements found from the passed argument elements all
  // the way down to child elements; pass a '<form>' or form fields.
  // called with 'this'=callback to use for serial() on each element
  function eachFormElement() {
    var cb = this
      , e, i
      , serializeSubtags = function (e, tags) {
          var i, j, fa
          for (i = 0; i < tags.length; i++) {
            fa = e[byTag](tags[i])
            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
          }
        }

    for (i = 0; i < arguments.length; i++) {
      e = arguments[i]
      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
    }
  }

  // standard query string style serialization
  function serializeQueryString() {
    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
  }

  // { 'name': 'value', ... } style serialization
  function serializeHash() {
    var hash = {}
    eachFormElement.apply(function (name, value) {
      if (name in hash) {
        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
        hash[name].push(value)
      } else hash[name] = value
    }, arguments)
    return hash
  }

  // [ { name: 'name', value: 'value' }, ... ] style serialization
  reqwest.serializeArray = function () {
    var arr = []
    eachFormElement.apply(function (name, value) {
      arr.push({name: name, value: value})
    }, arguments)
    return arr
  }

  reqwest.serialize = function () {
    if (arguments.length === 0) return ''
    var opt, fn
      , args = Array.prototype.slice.call(arguments, 0)

    opt = args.pop()
    opt && opt.nodeType && args.push(opt) && (opt = null)
    opt && (opt = opt.type)

    if (opt == 'map') fn = serializeHash
    else if (opt == 'array') fn = reqwest.serializeArray
    else fn = serializeQueryString

    return fn.apply(null, args)
  }

  reqwest.toQueryString = function (o, trad) {
    var prefix, i
      , traditional = trad || false
      , s = []
      , enc = encodeURIComponent
      , add = function (key, value) {
          // If value is a function, invoke it and return its value
          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
          s[s.length] = enc(key) + '=' + enc(value)
        }
    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(o)) {
      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in o) {
        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
      }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+')
  }

  function buildParams(prefix, obj, traditional, add) {
    var name, i, v
      , rbracket = /\[\]$/

    if (isArray(obj)) {
      // Serialize array item.
      for (i = 0; obj && i < obj.length; i++) {
        v = obj[i]
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
        }
      }
    } else if (obj && obj.toString() === '[object Object]') {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }

    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  reqwest.getcallbackPrefix = function () {
    return callbackPrefix
  }

  // jQuery and Zepto compatibility, differences can be remapped here so you can call
  // .ajax.compat(options, callback)
  reqwest.compat = function (o, fn) {
    if (o) {
      o['type'] && (o['method'] = o['type']) && delete o['type']
      o['dataType'] && (o['type'] = o['dataType'])
      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
    }
    return new Reqwest(o, fn)
  }

  reqwest.ajaxSetup = function (options) {
    options = options || {}
    for (var k in options) {
      globalSetupOptions[k] = options[k]
    }
  }

  return reqwest
});

});
},{"30":30,"8":8}],158:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*! http://mths.be/startswith v0.2.0 by @mathias */
if (!String.prototype.startsWith) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var toString = {}.toString;
		var startsWith = function(search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var position = arguments.length > 1 ? arguments[1] : undefined;
			// `ToInteger`
			var pos = position ? Number(position) : 0;
			if (pos != pos) { // better `isNaN`
				pos = 0;
			}
			var start = Math.min(Math.max(pos, 0), stringLength);
			// Avoid the `indexOf` call if no match is possible
			if (searchLength + start > stringLength) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'startsWith', {
				'value': startsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.startsWith = startsWith;
		}
	}());
}

});
},{"8":8}],159:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = {
  /* signin */
  'signin.generic.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.denied.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.unauthorized': {
    'signin.password': {
      msg: 'Sorry, we don\'t recognise your username or password.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.generic.banned': {
    'signin.password': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.banned': {
    'signin.password': {
      msg: 'This user has been banned.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.disapproved': {
    'signin.password': {
      msg: 'This user has been disapproved.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.possible spam activity': {
    'signin.password': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.locked out': {
    'signin.password': {
      msg: 'This user has been locked out.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.identification.any.empty': {
    'signin.userName': {
      msg: 'Please enter your username.',
      state: 'error'
    }
  },
  'signin.password.any.empty': {
    'signin.password': {
      msg: 'Please enter your password.',
      state: 'error'
    }
  },
  /* registration */
  'registration.generic.error': {
    'registration.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'registration.denied.error': {
    'registration.password': {
      msg: 'This user is not allowed to register. Please contact customer support.',
      state: 'error'
    }
  },
  'registration..spam': {
    'registration.password': {
      msg: 'Contact customer support',
      state: 'error'
    }
  },
  'registration.username.any.empty': {
    'registration.username': {
      msg: 'Please choose a username.',
      state: 'error'
    }
  },
  'registration.username.string.min': {
    'registration.username': {
      msg: 'Usernames must be at least three characters long.',
      state: 'error'
    }
  },
  'registration.username.string.max': {
    'registration.username': {
      msg: 'Usernames must be no more than 30 characters long.',
      state: 'error'
    }
  },
  'registration.email.duplicate': {
    'registration.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'registration.email.string.email': {
    'registration.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'registration.email.any.empty': {
    'registration.email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'registration.username.string.regex.base': {
    'registration.username': {
      msg: 'Usernames can only contain letters, numbers and the characters _ or -.',
      state: 'error'
    }
  },
  'registration.username.duplicate': {
    'registration.username': {
      msg: 'This username has already been taken.',
      state: 'error'
    }
  },
  'registration.password.any.empty': {
    'registration.password': {
      msg: 'Please choose a password.',
      state: 'error'
    }
  },
  'registration.password.string.min': {
    'registration.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'registration.firstName.any.empty': {
    'registration.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'registration.lastName.any.empty': {
    'registration.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.incomplete': {
    // necessary for a invalid date
  },
  'registration.dateOfBirth.invalid': {
    'registration.dateOfBirth': {
      msg: 'The date is not valid.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.future': {
    'registration.dateOfBirth': {
      msg: 'The date of birth should be set in the past.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.tooYoung': {
    'registration.dateOfBirth': {
      msg: 'You should be at least 2 years old.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.tooOld': {
    'registration.dateOfBirth': {
      msg: 'Are you really older than 120 years old?',
      state: 'error'
    }
  },
  'registration.guardianEmail.string.email': {
    'registration.guardianEmail': {
      msg: 'The guardian email should be a valid email.',
      state: 'error'
    }
  },
  'registration.guardianEmail.any.empty': {
    'registration.guardianEmail': {
      msg: 'The guardian email or Tes Teach class code should not be empty.',
      state: 'error'
    }
  },
  'registration.classCode.any.empty': {
    'registration.classCode': {
      msg: 'The Tes Teach class code should not be empty.',
      state: 'error'
    }
  },
  'registration.classCode.invalid': {
    'registration.classCode': {
      msg: 'The Tes Teach class code is not valid.',
      state: 'error'
    }
  },
  /* google */
  'google.generic.error': {
    'generic.googlebutton': {
      msg: 'Google error.',
      state: 'error'
    }
  },
  'google.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'facebook.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Facebook couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'google.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Google popup has been closed.',
      state: 'error'
    }
  },
  'facebook.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Facebook popup has been closed.',
      state: 'error'
    }
  },
  'google.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Google popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'facebook.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Facebook popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'google.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  'facebook.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Facebook couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  /* forgot-password */
  'forgot-password.generic.error': {
    'forgot-password.identification': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'forgot-password.denied.error': {
    'forgot-password.identification': {
      msg: 'This user is not allowed to reset the password. Please contact customer support.',
      state: 'error'
    }
  },
  'forgot-password.email.string.email': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.email.any.empty': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.user.not-found': {
    'forgot-password.identification': {
      msg: 'Sorry, we don\'t recognise that email address.',
      state: 'error'
    }
  },
  'forgot-password.generic.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    }
  },
  'forgot-password.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned.',
      state: 'error'
    }
  },
  'forgot-password.disapproved': {
    'forgot-password.identification': {
      msg: 'This user has been disapproved.',
      state: 'error'
    }
  },
  'forgot-password.possible spam activity': {
    'forgot-password.identification': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    }
  },
  'forgot-password.locked out': {
    'forgot-password.identification': {
      msg: 'This user has been locked out.',
      state: 'error'
    }
  },
  /* resend-confirmation-email */
  'resend-confirmation-email.generic.error': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.any.empty': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.string.email': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.generic-success': {
    submitted: true,
    success: true
  },
  'reset-password.invalid-token': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, that reset link didn\'t work. Please try a new one.',
      state: 'error'
    }
  },
  /* reset-password */
  'reset-password.generic.error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.server-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.token-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, this link is not valid any more. Can you ask for a new one?',
      state: 'error'
    }
  },
  'reset-password.unable': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, We are unable to change the password, have you already changed it?',
      state: 'error'
    }
  },
  'reset-password.blocked': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, This user is blocked/banned. Contact customer support.',
      state: 'error'
    }
  },
  'reset-password.generic-success': {
    submitted: true,
    success: true
  },
  'edit-account.generic.error': {
    'edit-account.userType': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    },
    'edit-account.message': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'edit-account.userType.any.allowOnly': {
    'edit-account.userType': {
      msg: 'The user type is not correct, please pick one',
      state: 'error'
    }
  },
  'edit-account.firstName.any.empty': {
    'edit-account.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'edit-account.lastName.any.empty': {
    'edit-account.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'edit-account.email.duplicate': {
    'edit-account.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'edit-account.email.string.email': {
    'edit-account.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'edit-account.email.any.empty': {
    'edit-account.email': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'change-password.generic.error': {
    'change-password.password': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'change-password.password.string.min': {
    'change-password.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'change-password.oldpassword.wrong': {
    'change-password.oldPassword': {
      msg: 'Your password is not correct, please try entering it again.',
      state: 'error'
    }
  },
  'change-password.samepassword': {
    'change-password.password': {
      msg: 'The new password is the same as the previous password.',
      state: 'error'
    }
  },
  'change-password.ok': {
    'change-password.message': {
      msg: 'You have succesfully changed your password.',
      state: 'success'
    }
  }
};

exports.default = function (codes) {
  if (!codes) return {};
  var errorCodes = codes.split(',');
  var validErrorCodes = errorCodes.filter(function (code) {
    return code in errors;
  });

  if (validErrorCodes.length === 0) {
    var prefix = errorCodes[0].split('.', 1);
    validErrorCodes.push(prefix + '.generic.error');
  }

  return validErrorCodes.map(function (code) {
    return errors[code];
  }).reduce(function (previous, current) {
    return (0, _assign2.default)({}, previous, current);
  }, {});
};

});
},{"12":12,"8":8}],160:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _Signin = require(167);

var _Signin2 = _interopRequireDefault(_Signin);

var _ForgotPassword = require(161);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _SelectPosition = require(166);

var _SelectPosition2 = _interopRequireDefault(_SelectPosition);

var _LoggedInUpdate = require(163);

var _LoggedInUpdate2 = _interopRequireDefault(_LoggedInUpdate);

var _LoggedInSelectPosition = require(162);

var _LoggedInSelectPosition2 = _interopRequireDefault(_LoggedInSelectPosition);

var _Register = require(164);

var _Register2 = _interopRequireDefault(_Register);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TesModalContainer(_ref) {
  var hasWrapper = _ref.hasWrapper,
      noWrapperStyle = _ref.noWrapperStyle,
      children = _ref.children;

  if (!hasWrapper) return _react2.default.createElement(
    'div',
    { style: noWrapperStyle },
    children
  );
  return _react2.default.createElement(
    'div',
    { className: 'tes-modal__body' },
    children
  );
}

TesModalContainer.propTypes = {
  hasWrapper: _react.PropTypes.bool,
  noWrapperStyle: _react.PropTypes.object
};

var App = exports.App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.trackDisplay(this.props.common.formType);
      if (!this.props.common.isModal && !this.props.common.isInline) {
        this.props.actions.failRegister(this.props.errors);
        this.props.actions.failSignIn(this.props.errors);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isModal = this.props.common.isModal;

      var borderStyle = {};
      var components = {
        'sign-in': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Signin2.default, null)
        ),
        register: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Register2.default, null)
        ),
        'forgot-password': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_ForgotPassword2.default, null)
        ),
        select: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false, noWrapperStyle: isModal ? {} : borderStyle },
          _react2.default.createElement(_SelectPosition2.default, { onClick: function onClick() {}, action: '', method: '' })
        ),
        'logged-in-select': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false },
          _react2.default.createElement(_LoggedInSelectPosition2.default, null)
        ),
        'logged-in-update': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_LoggedInUpdate2.default, null)
        )
      };
      var component = components[this.props.common.formType];
      return component;
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(App);

});
},{"15":15,"161":161,"162":162,"163":163,"164":164,"166":166,"167":167,"181":181,"21":21,"22":22,"25":25,"26":26,"8":8}],161:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPassword = undefined;

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('forgot-password');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('forgot-password');

var ForgotPassword = exports.ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    (0, _classCallCheck3.default)(this, ForgotPassword);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.actions.initForgotPassword();
    }
  }, {
    key: 'handleContinue',
    value: function handleContinue(e) {
      e.preventDefault();
      this.props.actions.successForgotPassword();
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('forgot-password.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'forgot-password.' + namepar;
      var deps = depspar.map(function (n) {
        return 'forgotpassword.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('forgotPassword', target.name, target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      var content = void 0;
      if (this.props.forgotPassword.state === 'sent') {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Email sent! Please now check your inbox'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'These emails can get caught in spam - please also check your spam folder.'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return _this3.handleContinue(e);
              }, className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary' },
            'Continue',
            _react2.default.createElement('span', { 'aria-hidden': 'true' })
          )
        );
      } else {
        content = _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return _this3.handleSubmit(e);
            }, role: 'form', method: 'post', className: 't-forgot-password-form' },
          _react2.default.createElement(_HiddenInputs2.default, null),
          _react2.default.createElement(
            'div',
            { className: getErrorCls('identification')(err) },
            _react2.default.createElement(
              'div',
              { className: 'tes-input-group' },
              _react2.default.createElement(
                'span',
                { className: 'tes-input-group__addon' },
                _react2.default.createElement('i', { className: 'icon icon-user' })
              ),
              _react2.default.createElement('input', { type: 'text', onChange: this.changeField('identification', []),
                name: 'identification',
                autoFocus: 'true',
                placeholder: 'email',
                value: this.props.forgotPassword.identification,
                className: 'tes-control tes-control--group identification-field t-identification'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tes-help-block' },
              getErrorMsg('identification')(err)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-md margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { disabled: this.props.forgotPassword.state === 'wait' ? 'disabled' : null, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary forgot-password-submit' },
              this.props.forgotPassword.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white' }) : 'Send'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Recover your password'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Send us your email and we will send you instructions to reset your password.'
          )
        ),
        content,
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-sm border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Remember your password?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(ForgotPassword);

});
},{"15":15,"16":16,"171":171,"173":173,"177":177,"181":181,"21":21,"22":22,"25":25,"26":26,"8":8}],162:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoggedInSelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require(165);

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoggedInSelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    isStandAlone: true,
    action: '/api/authn/edit-account',
    method: 'post'
  });
}

});
},{"165":165,"8":8}],163:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInUpdate = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _InputField = require(172);

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var LoggedInUpdate = exports.LoggedInUpdate = function (_Component) {
  (0, _inherits3.default)(LoggedInUpdate, _Component);

  function LoggedInUpdate(props) {
    (0, _classCallCheck3.default)(this, LoggedInUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedInUpdate.__proto__ || (0, _getPrototypeOf2.default)(LoggedInUpdate)).call(this, props));

    _this.state = {
      firstName: '',
      lastName: '',
      email: '',
      userType: _this.props.common.userType
    };
    return _this;
  }

  (0, _createClass3.default)(LoggedInUpdate, [{
    key: 'onChange',
    value: function onChange(e, name) {
      var data = {};
      data[name] = e.target.value;
      this.setState(data);
    }
  }, {
    key: 'getActiveFields',
    value: function getActiveFields() {
      var variants = {
        fullname: {
          title: 'Please add your full name',
          helpLink: 'Why are you being asked for your name?',
          helpText: 'This section of our site requires your name as you will be interacting with schools, institutions or other members of TES in a professional context. Using your actual name here improves the service and will allow you to interact with others with greater transparency and trust.',
          validFields: ['firstName', 'lastName']
        },
        email: {
          title: 'Please add your email',
          validFields: ['email', 'userType']
        }
      };

      if (!variants[this.props.common.variant]) {
        return variants.fullname;
      }
      return variants[this.props.common.variant];
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();

      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      var data = {};
      if (hasField('firstName')) {
        data.firstName = this.state.firstName;
      }
      if (hasField('lastName')) {
        data.lastName = this.state.lastName;
      }
      if (hasField('email')) {
        data.email = this.state.email;
      }
      if (hasField('userType')) {
        data.userType = this.state.userType;
      }
      this.props.actions.resetErrors();
      this.props.actions.updateUserData(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var err = this.props.errors;
      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      return _react2.default.createElement(
        'div',
        { id: 'logged-in-update', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            activeFields.title
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this2.handleSubmit(e);
              }, className: 't-logged-in-update margin-bottom-md', method: 'post', action: '/api/authn/edit-account' },
            this.props.common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: encodeURIComponent(this.props.common.rtn) }) : null,
            hasField('userType') && this.props.common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', ref: 'userType', value: this.props.common.userType }) : null,
            _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: this.props.common.appId }),
            _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: this.props.common.csrfToken }),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('firstName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.state.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'firstName');
                  },
                  autoFocus: 'true'
                }) : null
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('lastName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'Last name', value: this.state.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'lastName');
                  }
                }) : null
              )
            ),
            hasField('email') ? _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.state.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: function onChange(e) {
                return _this2.onChange(e, 'email');
              }
            }) : null,
            activeFields.helpLink ? _react2.default.createElement(
              'div',
              { className: 'margin-bottom-xs' },
              _react2.default.createElement(
                'span',
                { className: 'link link--colored text--xs', title: activeFields.helpText },
                activeFields.helpLink
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg tes-btn--block tes-btn--primary' },
                'Confirm'
              )
            )
          )
        )
      );
    }
  }]);
  return LoggedInUpdate;
}(_react.Component);

LoggedInUpdate.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(LoggedInUpdate);

});
},{"15":15,"172":172,"177":177,"181":181,"21":21,"22":22,"25":25,"26":26,"8":8}],164:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Register = undefined;

var _extends2 = require(24);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require(172);

var _InputField2 = _interopRequireDefault(_InputField);

var _dateHelper = require(175);

var _SimpleDate = require(140);

var _SimpleDate2 = _interopRequireDefault(_SimpleDate);

var _errorMessages = require(159);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _Branding = require(168);

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('registration');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('registration');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Register = exports.Register = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register(props) {
    (0, _classCallCheck3.default)(this, Register);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).call(this, props));

    var coppaEnabled = props.register.coppaEnabled;
    var isStudent = props.common.userType === 'student';
    _this.state = { expandPanel: !(isStudent && coppaEnabled) };
    return _this;
  }

  (0, _createClass3.default)(Register, [{
    key: 'onChangeDoB',
    value: function onChangeDoB(d) {
      var errorMessage = (0, _dateHelper.isInvalidDateOfBirth)(d);
      if (errorMessage) {
        this.setDateDoB(null);
        this.props.actions.validationErrors((0, _errorMessages2.default)(errorMessage));
      } else {
        this.props.actions.changeField('registration.dateOfBirth', []);
        this.setDateDoB(d);
      }
    }
  }, {
    key: 'setDateDoB',
    value: function setDateDoB(dob) {
      this.setState({ expandPanel: Boolean(dob) });
      this.props.actions.setField('register', 'dateOfBirth', dob);
    }
  }, {
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'getFacebookLogoURL',
    value: function getFacebookLogoURL() {
      return this.props.common.cdnUrl + 'img/facebook-logo.png';
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'registration.' + namepar;
      var deps = depspar.map(function (n) {
        return 'registration.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('register', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
        _this2.props.actions.validateField(name);
      };
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('registration.');
      }).length > 0 : false;
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initOauthSignIn('google');
    }
  }, {
    key: 'handleFacebook',
    value: function handleFacebook() {
      this.props.actions.initOauthSignIn('facebook');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;
      this.props.actions.initRegister(function () {
        target.submit(); // only called for pages
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$register = this.props.register,
          coppaEnabled = _props$register.coppaEnabled,
          dateOfBirth = _props$register.dateOfBirth;

      var err = this.props.errors;
      var hasName = !this.props.common.omitName;
      var isStudent = this.props.common.userType === 'student';
      var under13 = (0, _dateHelper.isUnder13)(dateOfBirth);
      var under18 = under13 || (0, _dateHelper.isUnder18)(dateOfBirth);
      var expandPanel = this.state.expandPanel;

      var wrapperStyle = {
        overflow: 'hidden',
        transition: expandPanel ? 'max-height 280ms linear, transform 200ms cubic-bezier(0.7, 0.54, 0.66, 1.20), opacity 200ms ease-out' : 'none',
        maxHeight: expandPanel ? '520px' : '0',
        transform: expandPanel ? 'scale(1,1)' : 'scale(1.15,0)',
        opacity: expandPanel ? '1' : '0'
      };

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        this.props.common.branding ? _react2.default.createElement(_Branding2.default, (0, _extends3.default)({}, this.props.common.branding, { cdnUrl: this.props.common.cdnUrl })) : _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Join TES for free'
          )
        ),
        coppaEnabled && isStudent ? _react2.default.createElement(
          'div',
          { className: getErrorCls('dateOfBirth')(err) },
          _react2.default.createElement(
            'label',
            { className: 'padding-right-xs', htmlFor: 'dateOfBirth-month' },
            'What is your date of birth?'
          ),
          _react2.default.createElement(_SimpleDate2.default, {
            name: 'dateOfBirth',
            value: this.props.register.dateOfBirth,
            onChange: function onChange(d) {
              return _this3.onChangeDoB(d);
            },
            label: 'Date of birth',
            sequence: this.props.common.dateLocale
          }),
          _react2.default.createElement(
            'div',
            { className: 'tes-help-block' },
            getErrorMsg('dateOfBirth')(err)
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: wrapperStyle },
          _react2.default.createElement(
            'div',
            null,
            !isStudent || !under18 || !coppaEnabled ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  _react2.default.createElement(
                    'button',
                    {
                      disabled: this.props.register.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                      onClick: function onClick(e) {
                        return _this3.handleGoogle(e);
                      },
                      className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                    },
                    this.props.common.oauthState === 'google' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                      'span',
                      { className: 'text--sm' },
                      _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getGoogleLogoURL() }),
                      ' Register with Google'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row margin-top-sm' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  _react2.default.createElement(
                    'button',
                    {
                      disabled: this.props.register.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                      onClick: function onClick(e) {
                        return _this3.handleFacebook(e);
                      },
                      className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                    },
                    this.props.common.oauthState === 'facebook' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                      'span',
                      { className: 'text--sm' },
                      _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getFacebookLogoURL() }),
                      ' Register with Facebook'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'separator' },
                _react2.default.createElement(
                  'span',
                  { className: 'separator--text bg-white' },
                  'or'
                )
              )
            ) : null,
            _react2.default.createElement(
              'form',
              { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                  return _this3.handleSubmit(e);
                }, className: 't-register-form margin-bottom-md', method: 'post', action: '/api/authn/register-redirect' },
              _react2.default.createElement(_HiddenInputs2.default, null),
              coppaEnabled && isStudent ? _react2.default.createElement('input', { type: 'hidden', name: 'dateOfBirth', value: this.props.register.dateOfBirth }) : null,
              hasName ? _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 col-sm-6' },
                  _react2.default.createElement(_InputField2.default, {
                    name: 'firstName', label: 'First name', value: this.props.register.firstName,
                    errorClass: getErrorCls('firstName')(err),
                    errorMessage: getErrorMsg('firstName')(err),
                    onChange: this.changeField('firstName', [])
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 col-sm-6' },
                  _react2.default.createElement(_InputField2.default, {
                    name: 'lastName', label: 'Last name', value: this.props.register.lastName,
                    errorClass: getErrorCls('lastName')(err),
                    errorMessage: getErrorMsg('lastName')(err),
                    onChange: this.changeField('lastName', [])
                  })
                )
              ) : null,
              !isStudent || !under13 || !coppaEnabled ? _react2.default.createElement(_InputField2.default, {
                name: 'email',
                label: this.props.common.userType === 'student' && (under18 || !coppaEnabled) ? 'Email (optional)' : 'Email',
                value: this.props.register.email,
                errorClass: getErrorCls('email')(err),
                errorMessage: getErrorMsg('email')(err),
                onChange: this.changeField('email', []),
                type: 'email'
              }) : null,
              _react2.default.createElement(_InputField2.default, {
                name: 'username',
                label: 'Username',
                value: this.props.register.username,
                errorClass: getErrorCls('username')(err),
                errorMessage: getErrorMsg('username')(err),
                onChange: this.changeField('username', [])
              }),
              _react2.default.createElement(_InputField2.default, {
                name: 'password',
                label: 'password',
                value: this.props.register.password,
                errorClass: getErrorCls('password')(err),
                errorMessage: getErrorMsg('password')(err),
                onChange: this.changeField('password', []),
                type: 'password'
              }),
              coppaEnabled && isStudent && under13 ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_InputField2.default, {
                  name: 'classCode',
                  label: 'Class code from Tes Teach',
                  value: this.props.register.classCode,
                  errorClass: getErrorCls('classCode')(err),
                  errorMessage: getErrorMsg('classCode')(err),
                  onChange: this.changeField('classCode', [])
                })
              ) : null,
              this.props.common.userType !== 'student' ? _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline text--sm margin-bottom-sm' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label text--xs' },
                  _react2.default.createElement('input', { onChange: this.changeField('newsletter', []),
                    type: 'checkbox', name: 'newsletter',
                    className: 't-newsletter',
                    value: 'true',
                    checked: this.props.register.newsletter
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'text--xs' },
                    ' Receive news and updates from TES'
                  )
                )
              ) : null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  { disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                    type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg sign-up-submit tes-btn--block tes-btn--primary'
                  },
                  this.props.register.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Register'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'text--secondary col-xs-12', style: { paddingRight: 0 } },
                _react2.default.createElement(
                  'div',
                  { className: 'margin-bottom-md' },
                  'By registering, you are agreeing to our ',
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', className: 'link link--colored', href: 'https://www.tes.com/content/terms-and-conditions' },
                    'terms and conditions'
                  ),
                  ' and ',
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', className: 'link link--colored', href: 'https://www.tes.com/us/privacy-policy' },
                    'privacy policy'
                  )
                )
              )
            ),
            getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'tes-has-error col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'tes-help-block' },
                  getGenericErrorMsg('googlebutton')(err)
                )
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return Register;
}(_react.Component);

Register.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    register: state.register
  };
}, mapDispatchToProps)(Register);

});
},{"140":140,"15":15,"159":159,"16":16,"168":168,"171":171,"172":172,"173":173,"175":175,"177":177,"181":181,"21":21,"22":22,"24":24,"25":25,"26":26,"8":8}],165:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFormPosition = undefined;

var _extends2 = require(24);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _CustomSelect = require(170);

var _CustomSelect2 = _interopRequireDefault(_CustomSelect);

var _ButtonSelect = require(169);

var _ButtonSelect2 = _interopRequireDefault(_ButtonSelect);

var _positionFilter = require(178);

var _Branding = require(168);

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectFormPosition = exports.SelectFormPosition = function (_Component) {
  (0, _inherits3.default)(SelectFormPosition, _Component);

  function SelectFormPosition(props) {
    (0, _classCallCheck3.default)(this, SelectFormPosition);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectFormPosition.__proto__ || (0, _getPrototypeOf2.default)(SelectFormPosition)).call(this, props));

    var positions = props.refdata.positions;
    var careers = props.refdata.careers;
    var currentPosition = props.common.position;
    var currentCareerObj = (0, _positionFilter.careerFinder)(positions, careers, currentPosition);

    _this.state = { currentCareerObj: currentCareerObj };
    return _this;
  }

  (0, _createClass3.default)(SelectFormPosition, [{
    key: 'onChangeCareer',
    value: function onChangeCareer(currentCareer) {
      var _this2 = this;

      var filteredCareers = this.props.refdata.careers.filter(function (item) {
        return currentCareer === item.name;
      });
      var currentCareerObj = filteredCareers.length ? filteredCareers[0] : { name: '', groupLabel: null };

      this.setState({ currentCareerObj: currentCareerObj });

      var positions = this.props.refdata.positions;
      var validPosition = (0, _positionFilter.filterPosition)(positions, currentCareerObj);

      var newPosition = validPosition.length === 1 ? validPosition[0].name : '';
      var newUserType = validPosition.length === 1 ? validPosition[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
      if (!currentCareerObj.groupLabel) {
        setTimeout(function () {
          return _this2.refs.submit.click();
        }, 50); // wait to render the interface with the correct field
      }
    }
  }, {
    key: 'onChangePosition',
    value: function onChangePosition(newPosition) {
      var _this3 = this;

      var positions = this.props.refdata.positions;
      var filteredPositions = positions.filter(function (p) {
        return newPosition === p.name;
      });

      var newUserType = filteredPositions.length ? filteredPositions[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
      setTimeout(function () {
        return _this3.refs.submit.click();
      }, 50); // wait to render the interface with the correct field
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      var position = this.props.common.position;
      var userType = (0, _positionFilter.getUserTypePosition)(this.props.refdata.positions, position);

      this.props.actions.setUserType(userType);

      if (this.props.isStandAlone) {
        this.props.actions.updateUserData({ userType: userType, position: position });
      } else {
        this.props.actions.initSetFormType('register');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props$refdata = this.props.refdata,
          positions = _props$refdata.positions,
          careers = _props$refdata.careers;

      var currentPosition = this.props.common.position;
      var currentCareerObj = this.state.currentCareerObj;

      var positionOptions = (0, _positionFilter.filterPosition)(positions, currentCareerObj).map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      var careerOptions = careers.map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      return _react2.default.createElement(
        'div',
        { id: 'select-position' },
        this.props.common.branding ? _react2.default.createElement(
          'div',
          { className: 'padding-left-md padding-right-md' },
          _react2.default.createElement(_Branding2.default, (0, _extends3.default)({}, this.props.common.branding, { cdnUrl: this.props.common.cdnUrl, margin: false }))
        ) : _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_top' },
          _react2.default.createElement(
            'div',
            { className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
            _react2.default.createElement(
              'div',
              { className: 'heading-main text-center' },
              _react2.default.createElement(
                'h3',
                { className: 'tes-modal__heading margin-bottom-sm' },
                'Join TES for free'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_middle' },
          _react2.default.createElement(
            'div',
            { className: 'padding-md' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h4',
                { className: 'tes-modal__heading text--white text-white margin-bottom-sm' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I am a ...'
                )
              )
            ),
            _react2.default.createElement(
              'form',
              { autoComplete: 'off', className: 't-student-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onSubmit
              },
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noPosition: true }),
              _react2.default.createElement(
                'div',
                { className: 'padding-bottom-md' },
                _react2.default.createElement(_ButtonSelect2.default, {
                  id: 'career-selector',
                  onChange: function onChange(v) {
                    return _this4.onChangeCareer(v);
                  },
                  value: currentCareerObj.name,
                  options: careerOptions,
                  emptyOptionLabel: 'Choose your role'
                })
              ),
              currentCareerObj.groupLabel ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'padding-bottom-md' },
                  _react2.default.createElement(_CustomSelect2.default, {
                    id: 'position-selector',
                    className: 'tes-control tes-select',
                    name: 'position',
                    onChange: function onChange(v) {
                      return _this4.onChangePosition(v);
                    },
                    value: currentPosition,
                    options: positionOptions,
                    emptyOptionLabel: 'Choose a position'
                  })
                )
              ) : _react2.default.createElement('input', { type: 'hidden', name: 'position', value: currentPosition }),
              _react2.default.createElement(
                'button',
                { ref: 'submit', onClick: function onClick(e) {
                    return _this4.onSubmit(e);
                  }, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary hidden' },
                'Ok'
              )
            )
          )
        ),
        !this.props.isStandAlone ? _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_bottom' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a TES account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        ) : null
      );
    }
  }]);
  return SelectFormPosition;
}(_react.Component);

SelectFormPosition.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  refdata: _react.PropTypes.object.isRequired,
  isStandAlone: _react.PropTypes.bool,
  action: _react.PropTypes.string.isRequired,
  method: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    refdata: state.refdata
  };
}, mapDispatchToProps)(SelectFormPosition);

});
},{"15":15,"168":168,"169":169,"170":170,"171":171,"173":173,"178":178,"181":181,"21":21,"22":22,"24":24,"25":25,"26":26,"8":8}],166:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require(165);

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    action: '/authn/register',
    method: 'get'
  });
}

});
},{"165":165,"8":8}],167:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signin = undefined;

var _extends2 = require(24);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require(172);

var _InputField2 = _interopRequireDefault(_InputField);

var _Branding = require(168);

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('signin');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('signin');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Signin = exports.Signin = function (_Component) {
  (0, _inherits3.default)(Signin, _Component);

  function Signin() {
    (0, _classCallCheck3.default)(this, Signin);
    return (0, _possibleConstructorReturn3.default)(this, (Signin.__proto__ || (0, _getPrototypeOf2.default)(Signin)).apply(this, arguments));
  }

  (0, _createClass3.default)(Signin, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'getFacebookLogoURL',
    value: function getFacebookLogoURL() {
      return this.props.common.cdnUrl + 'img/facebook-logo.png';
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initOauthSignIn('google');
    }
  }, {
    key: 'handleFacebook',
    value: function handleFacebook() {
      this.props.actions.initOauthSignIn('facebook');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;

      this.props.actions.initSignIn(function () {
        target.submit();
      });
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('signin.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'signin.' + namepar;
      var deps = depspar.map(function (n) {
        return 'signin.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('signIn', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        this.props.common.branding ? _react2.default.createElement(_Branding2.default, (0, _extends3.default)({}, this.props.common.branding, { cdnUrl: this.props.common.cdnUrl })) : _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Please log in'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                },
                this.props.common.oauthState === 'google' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text--sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getGoogleLogoURL() }),
                  ' Log in with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-top-sm' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleFacebook(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                },
                this.props.common.oauthState === 'facebook' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text--sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getFacebookLogoURL() }),
                  ' Log in with Facebook'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, role: 'form', className: 't-sign-in-form margin-bottom-sm', method: 'post', action: '/api/authn/sign-in-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-white' },
                'or'
              )
            ),
            _react2.default.createElement(_InputField2.default, {
              name: 'identification',
              label: 'Username or email',
              icon: 'user',
              value: this.props.signIn.identification,
              errorClass: getErrorCls('userName')(err),
              errorMessage: getErrorMsg('userName')(err),
              onChange: this.changeField('userName', ['password']),
              autoFocus: 'true',
              autoComplete: 'off'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'Password',
              icon: 'lock',
              value: this.props.signIn.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', ['userName']),
              type: 'password',
              autoComplete: 'off'
            }),
            _react2.default.createElement(
              'div',
              { className: 'text--sm margin-bottom-md margin-top-md' },
              _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label', title: 'This shouldn\'t be used on a shared computer' },
                  _react2.default.createElement('input', { type: 'checkbox',
                    name: 'trustedComputer',
                    value: 'true',
                    checked: this.props.signIn.trustedComputer,
                    onChange: this.changeField('trustedComputer', [])
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'text--sm' },
                    'Stay logged in'
                  )
                )
              ),
              _react2.default.createElement(
                _WidgetLink2.default,
                { formType: 'forgotPassword' },
                'Forgot password?'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--lg sign-in-submit tes-btn--icon tes-btn--block tes-btn--primary'
                },
                this.props.signInstate === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Log in'
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 tes-has-error' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-sm' },
            _react2.default.createElement(
              'span',
              null,
              'Not a member yet?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'register' },
              'Join us for free'
            )
          )
        )
      );
    }
  }]);
  return Signin;
}(_react.Component);

Signin.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn
  };
}, mapDispatchToProps)(Signin);

});
},{"15":15,"16":16,"168":168,"171":171,"172":172,"173":173,"177":177,"181":181,"21":21,"22":22,"24":24,"25":25,"26":26,"8":8}],168:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Branding(_ref) {
  var logo = _ref.logo,
      name = _ref.name,
      text = _ref.text,
      cdnUrl = _ref.cdnUrl,
      _ref$margin = _ref.margin,
      margin = _ref$margin === undefined ? true : _ref$margin;

  var classes = ['text-center', margin ? 'margin-bottom-lg' : '', 'auth-brand-' + name, 'heading--sm', 'heading--bold', 'text--white', 'padding-sm'];

  return _react2.default.createElement(
    'div',
    { className: classes.join(' ') },
    _react2.default.createElement('img', { src: cdnUrl + 'img/' + logo, height: '39' }),
    _react2.default.createElement(
      'p',
      null,
      text
    )
  );
}

Branding.propTypes = {
  logo: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  text: _react.PropTypes.string.isRequired,
  cdnUrl: _react.PropTypes.string.isRequired,
  margin: _react.PropTypes.bool
};

exports.default = Branding;

});
},{"8":8}],169:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonSelect = function (_Component) {
  (0, _inherits3.default)(ButtonSelect, _Component);

  function ButtonSelect(props) {
    (0, _classCallCheck3.default)(this, ButtonSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ButtonSelect.__proto__ || (0, _getPrototypeOf2.default)(ButtonSelect)).call(this, props));

    _this.state = { value: props.value || '' };
    return _this;
  }

  (0, _createClass3.default)(ButtonSelect, [{
    key: 'onClick',
    value: function onClick(e, value) {
      e.preventDefault();
      var newValue = value;
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;

      return _react2.default.createElement(
        'div',
        {
          id: this.props.id,
          className: this.props.className
        },
        this.props.name ? _react2.default.createElement('input', { type: 'hidden', value: this.state.value, name: this.props.name }) : null,
        options.map(function (p, index) {
          return p.value === _this2.state.value ? _react2.default.createElement(
            'div',
            { key: 'select-button-' + index, className: 'margin-top-sm margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { className: 'tes-btn tes-btn--secondary-gray-text tes-btn--block', disabled: true },
              p.label
            )
          ) : _react2.default.createElement(
            'div',
            { key: 'select-button-' + index, className: 'margin-top-sm margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { className: 'tes-btn tes-btn--primary tes-btn--block', onClick: function onClick(e) {
                  return _this2.onClick(e, p.value);
                } },
              p.label
            )
          );
        })
      );
    }
  }]);
  return ButtonSelect;
}(_react.Component);

exports.default = ButtonSelect;


ButtonSelect.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  options: _react.PropTypes.array.isRequired,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  name: _react.PropTypes.string
};

});
},{"15":15,"21":21,"22":22,"25":25,"26":26,"8":8}],170:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomSelect = function (_Component) {
  (0, _inherits3.default)(CustomSelect, _Component);

  function CustomSelect(props) {
    (0, _classCallCheck3.default)(this, CustomSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomSelect.__proto__ || (0, _getPrototypeOf2.default)(CustomSelect)).call(this, props));

    _this.state = { value: props.value || '' };
    return _this;
  }

  (0, _createClass3.default)(CustomSelect, [{
    key: 'onChange',
    value: function onChange(e) {
      var newValue = e.target.value;
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = [];
      if (this.props.emptyOptionLabel) {
        options.push({
          label: this.props.emptyOptionLabel,
          value: ''
        });
      }
      options = options.concat(this.props.options);

      return _react2.default.createElement(
        'select',
        {
          autoComplete: 'off',
          id: this.props.id,
          className: this.props.className,
          onChange: function onChange(e) {
            return _this2.onChange(e);
          },
          value: this.state.value,
          name: this.props.name
        },
        options.map(function (p, index) {
          return _react2.default.createElement(
            'option',
            { key: 'select-' + index, value: p.value },
            p.label
          );
        })
      );
    }
  }]);
  return CustomSelect;
}(_react.Component);

exports.default = CustomSelect;


CustomSelect.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  options: _react.PropTypes.array.isRequired,
  emptyOptionLabel: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  name: _react.PropTypes.string
};

});
},{"15":15,"21":21,"22":22,"25":25,"26":26,"8":8}],171:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInputs = HiddenInputs;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _tracking = require(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HiddenInputs(_ref) {
  var common = _ref.common,
      isGetRequest = _ref.isGetRequest,
      noUserType = _ref.noUserType,
      noPosition = _ref.noPosition;

  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var pageContextInputs = ['pageId', 'pageType', 'pageSection', 'pageSubSection'].filter(function (name) {
    return pageContext && pageContext[name];
  }).map(function (name) {
    return _react2.default.createElement('input', { type: 'hidden', key: name, name: name, value: pageContext[name] });
  });

  return _react2.default.createElement(
    'span',
    null,
    pageContextInputs,
    common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: common.rtn }) : null,
    !noUserType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', value: common.userType || 'other' }) : null,
    !noPosition && common.position ? _react2.default.createElement('input', { className: 't-position', type: 'hidden', name: 'position', value: common.position }) : null,
    common.regUrl ? _react2.default.createElement('input', { className: 't-reg-url', type: 'hidden', name: 'regUrl', value: common.regUrl }) : null,
    _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: common.appId }),
    !isGetRequest ? _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: common.csrfToken }) : null,
    common.doSelectUserType ? _react2.default.createElement('input', { className: 't-select', type: 'hidden', name: 'select', value: 'true' }) : null,
    common.hasOwnProperty('omitName') ? _react2.default.createElement('input', { type: 'hidden', name: 'omitName', value: common.omitName }) : null
  );
}

HiddenInputs.propTypes = {
  common: _react.PropTypes.object.isRequired,
  isGetRequest: _react.PropTypes.bool,
  noUserType: _react.PropTypes.bool,
  noPosition: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
})(HiddenInputs);

});
},{"179":179,"8":8}],172:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputGroup(_ref) {
  var icon = _ref.icon,
      children = _ref.children;

  if (!icon) return _react2.default.createElement(
    "div",
    null,
    children
  );
  return _react2.default.createElement(
    "div",
    { className: "tes-input-group" },
    _react2.default.createElement(
      "span",
      { className: "tes-input-group__addon" },
      _react2.default.createElement("i", { className: "icon icon-" + icon })
    ),
    children
  );
}

InputGroup.propTypes = {
  icon: _react.PropTypes.string
};

function InputField(_ref2) {
  var errorClass = _ref2.errorClass,
      errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      value = _ref2.value,
      name = _ref2.name,
      onChange = _ref2.onChange,
      type = _ref2.type,
      icon = _ref2.icon,
      autoFocus = _ref2.autoFocus,
      autoComplete = _ref2.autoComplete;

  var id = "auth-" + name;
  var widgetType = type || 'text';
  return _react2.default.createElement(
    "div",
    { className: errorClass },
    _react2.default.createElement(
      InputGroup,
      { icon: icon },
      _react2.default.createElement(
        "label",
        { className: "tes-control-label tes-control-label--hidden", htmlFor: id },
        label
      ),
      _react2.default.createElement("input", { onChange: onChange, id: id, type: widgetType,
        name: name,
        placeholder: label,
        className: "tes-control tes-input-group__control-last",
        value: value,
        autoFocus: autoFocus,
        autoComplete: autoComplete
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "tes-help-block" },
      errorMessage
    )
  );
}

InputField.propTypes = {
  errorClass: _react.PropTypes.string.isRequired,
  errorMessage: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string,
  value: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  autoFocus: _react.PropTypes.string,
  autoComplete: _react.PropTypes.string
};

exports.default = InputField;

});
},{"8":8}],173:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetLink = WidgetLink;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidgetLink(_ref) {
  var common = _ref.common,
      formType = _ref.formType,
      children = _ref.children,
      actions = _ref.actions;

  var registerPages = {
    signIn: 'sign-in',
    forgotPassword: 'forgot-password',
    register: common.doSelectUserType ? 'select' : 'register'
  };

  var registerPage = registerPages[formType];

  var switchTo = function switchTo(e) {
    if (!common.isModal && !common.isInline) return;
    e.preventDefault();
    actions.initSetFormType(registerPage);
  };

  var encodedRtn = encodeURIComponent(common.rtn);
  var encodedRegUrl = encodeURIComponent(common.regUrl);

  var qs = [];
  if (common.rtn) {
    qs.push('rtn=' + encodedRtn);
  }
  if (common.doSelectUserType) {
    qs.push('select=true');
  }
  if ('id' in common.overrideMz) {
    qs.push('pageId=' + common.overrideMz.id);
  }
  if ('type' in common.overrideMz) {
    qs.push('pageType=' + common.overrideMz.type);
  }
  if ('section' in common.overrideMz) {
    qs.push('pageSection=' + common.overrideMz.section);
  }
  if ('subsection' in common.overrideMz) {
    qs.push('pageSubSection=' + common.overrideMz.subsection);
  }
  if (common.regUrl) {
    qs.push('regUrl=' + encodedRegUrl);
  }
  if (common.hasOwnProperty('omitName')) {
    qs.push('omitName=' + common.omitName);
  }
  if (common.appId) {
    qs.push('appId=' + common.appId);
  }

  var baseURLs = {
    signIn: '/authn/sign-in',
    forgotPassword: '/authn/forgot-password',
    register: '/authn/' + registerPage
  };

  var baseURL = baseURLs[formType];
  var url = qs.length ? baseURL + '?' + qs.join('&') : baseURL;
  var extraClass = formType === 'forgotPassword' ? ' pull-right' : '';
  return _react2.default.createElement(
    'a',
    { onClick: switchTo, href: url, className: 't-switch-form link link--colored' + extraClass },
    children
  );
}

WidgetLink.propTypes = {
  common: _react.PropTypes.object.isRequired,
  actions: _react.PropTypes.object.isRequired,
  formType: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(WidgetLink);

});
},{"181":181,"8":8}],174:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _promise = require(18);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require(11);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require(27);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reqwest = require(157);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _retry = require(2);

var _retry2 = _interopRequireDefault(_retry);

var _memoize = require(1);

var _memoize2 = _interopRequireDefault(_memoize);

var _es6PromisePolyfill = require(132);

var _es6PromisePolyfill2 = _interopRequireDefault(_es6PromisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
try {
  window.Promise = _es6PromisePolyfill2.default.Promise;
} catch (e) {
  // nothing
}

var getOrigin = function getOrigin() {
  if (window.location.origin) {
    return window.location.origin;
  }
  var port = window.location.port ? ':' + window.location.port : '';
  var protocol = window.location.protocol;
  var hostname = window.location.hostname;
  return protocol + '//' + hostname + port;
};

var XHRTIMEOUT_WITH_RETRY = 9000;
var XHRTIMEOUT_WITHOUT_RETRY = 20000;

var defaultParams = {
  type: 'json',
  contentType: 'application/json',
  headers: {
    accept: 'application/json',
    'x-auth-api-version': '2'
  }
};

function postRequest(endpoint, data, times) {
  var requestFunction = void 0;
  var timeout = void 0;
  if (times) {
    var t0 = new Date();
    var retry = (0, _retry2.default)(times, 100, function (err) {
      return err && err.status === 0;
    }, function () {
      return function (t, o) {
        var t1 = new Date();
        console.log('app-authentication: api trying ' + o.times + ' after ' + (t1 - t0) + ' ms');
      };
    });
    requestFunction = retry(_reqwest2.default);
    timeout = XHRTIMEOUT_WITH_RETRY;
  } else {
    requestFunction = _reqwest2.default;
    timeout = XHRTIMEOUT_WITHOUT_RETRY;
  }

  var _ref = document.cookie.match(/csrf=([^;]*)/) || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      match = _ref2[0],
      csrfToken = _ref2[1];

  return requestFunction((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'POST',
    timeout: timeout,
    data: (0, _stringify2.default)(data),
    headers: (0, _assign2.default)({}, defaultParams.headers, match && csrfToken ? {
      'x-csrf-token': match && csrfToken
    } : {})
  }));
}

var memoize = (0, _memoize2.default)(function (d) {
  try {
    return d.data.email ? d.data.email : null;
  } catch (e) {
    return null;
  }
});
var cachedReqwest = memoize(_reqwest2.default);

function getRequest(endpoint, data) {
  var timeout = XHRTIMEOUT_WITHOUT_RETRY;

  return cachedReqwest((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'GET',
    timeout: timeout,
    data: data
  }));
}

var events = function getEvents() {
  try {
    return window.TES.events;
  } catch (e) {
    return {
      on: function on() {},
      trigger: function trigger() {}
    };
  }
}();

var api = {
  verifyUsername: function verifyUsername(username) {
    return getRequest('/api/authn/find-user', { username: username });
  },
  verifyEmail: function verifyEmail(email) {
    return getRequest('/api/authn/find-user', { email: email });
  },
  signIn: function signIn(data) {
    return postRequest('/api/authn/sign-in-redirect', data, 4);
  },
  register: function register(data) {
    return postRequest('/api/authn/register-redirect', data);
  },
  oauthSignIn: function oauthSignIn(provider, data) {
    return new _promise2.default(function (resolve, reject) {
      var params = (0, _keys2.default)(data).filter(function (k) {
        return !!data[k];
      }).map(function (k) {
        return [k, encodeURIComponent(data[k])];
      }).map(function (t) {
        return t[0] + '=' + t[1];
      }).join('&');

      var path = '/oauth/' + provider + '?' + params;

      if (!data.isModal) {
        return window.location.assign(path);
      }

      var done = false;

      var googlePopup = window.open(path, '', 'location=0,status=0,width=600,height=500');

      function onMessage(evt) {
        var msg = void 0;
        if (evt.origin !== getOrigin()) return;
        try {
          msg = (0, _typeof3.default)(evt.data) === 'object' ? evt.data : JSON.parse(evt.data);
        } catch (e) {
          // ie9 returns evt.data === undefined, but I won't care!!!!
          // this is also the case of non JSON messages
          return;
        }
        if (msg.sender !== 'googlepopup') {
          return;
        }
        if (msg.status === 'ok' || msg.status === 'error') {
          done = true;
          window.removeEventListener('message', onMessage);
          googlePopup.close();
        }
        if (msg.status === 'ok') {
          /* Comes from close-modal page */
          if (msg.needsPosition) {
            var err = new Error('Needs position data');
            err.needsPosition = true;
            return reject(err);
          }
          resolve();
        }
        if (msg.status === 'error') {
          reject(new Error(msg.errorCode));
        }
      }

      window.addEventListener('message', onMessage);

      var _oauthInterval = window.setInterval(function () {
        var fireError = function fireError(errorCode) {
          if (!done) {
            reject(new Error(errorCode));
          }
          window.removeEventListener('message', onMessage);
          window.clearInterval(_oauthInterval);
        };
        try {
          if (!googlePopup) {
            fireError(provider + '.popup.blocked');
          } else if (googlePopup.closed) {
            fireError(provider + '.popup.closed');
          }
        } catch (e) {
          // ie fires error here
        }
      }, 1000);
    });
  },
  forgotPassword: function forgotPassword(data) {
    return postRequest('/api/authn/forgot-password', data);
  },
  updateUserData: function updateUserData(data) {
    return postRequest('/api/authn/edit-account', data);
  },
  reload: function reload(url) {
    if (url) {
      window.location.assign(url);
    } else {
      window.location.reload(true);
    }
  },
  loggedInEvent: function loggedInEvent() {
    events.trigger('logged-in');
  },
  closeModalEvent: function closeModalEvent() {
    events.trigger('modal-close', 'authapp');
  }
};

exports.default = api;

});
},{"1":1,"11":11,"12":12,"132":132,"157":157,"16":16,"18":18,"2":2,"27":27,"28":28,"8":8}],175:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require(27);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.isInvalidDateOfBirth = isInvalidDateOfBirth;
exports.dateDiff = dateDiff;
exports.isUnder18 = isUnder18;
exports.isUnder13 = isUnder13;
exports.locale = locale;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deltayears(delta, today) {
  var d = today ? new Date(today) : new Date();
  d.setFullYear(d.getFullYear() + delta);
  return d;
}

function isInvalidDateOfBirth(d, today) {
  if (!d) return true;

  var _d$split$map = d.split('-').map(function (s) {
    return parseInt(s, 10);
  }),
      _d$split$map2 = (0, _slicedToArray3.default)(_d$split$map, 3),
      year = _d$split$map2[0],
      month = _d$split$map2[1],
      day = _d$split$map2[2];

  var date = new Date(year, month - 1, day);
  var twoyearsago = deltayears(-2, today);
  var onehundredandtwentyyearsago = deltayears(-120, today);
  var now = deltayears(0, today);

  if (year < 1000 || isNaN(date.getMonth())) {
    return 'registration.dateOfBirth.incomplete';
  } else if (!(date.getMonth() === month - 1 && date.getDate() === day && date.getFullYear() === year)) {
    return 'registration.dateOfBirth.invalid';
  } else if (now < date) {
    return 'registration.dateOfBirth.future';
  } else if (twoyearsago < date) {
    return 'registration.dateOfBirth.tooYoung';
  } else if (onehundredandtwentyyearsago > date) {
    return 'registration.dateOfBirth.tooOld';
  }
}

function dateDiff(date, today) {
  var _date$split$map = date.split('-').map(function (item) {
    return parseInt(item, 10);
  }),
      _date$split$map2 = (0, _slicedToArray3.default)(_date$split$map, 3),
      year = _date$split$map2[0],
      month = _date$split$map2[1],
      day = _date$split$map2[2];

  var d = today ? new Date(today) : new Date();
  var deltaYear = d.getFullYear() - year;
  var deltaMonth = d.getMonth() + 1 - month;
  var deltaDay = d.getDate() - day;
  if (deltaDay < 0) {
    deltaMonth -= 1;
    deltaDay += 30;
  }
  if (deltaMonth < 0) {
    deltaYear -= 1;
    deltaMonth += 12;
  }
  return { deltaYear: deltaYear, deltaMonth: deltaMonth, deltaDay: deltaDay };
}

function isUnder18(dob) {
  return !isInvalidDateOfBirth(dob) && dateDiff(dob).deltaYear < 18;
}

function isUnder13(dob) {
  return !isInvalidDateOfBirth(dob) && dateDiff(dob).deltaYear < 13;
}

function locale(siteCountry) {
  switch (siteCountry) {
    case 'CA':
    case 'US':
      return ['month', 'day', 'year'];
    default:
      return ['day', 'month', 'year'];
  }
}

});
},{"27":27,"8":8}],176:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDenied = authDenied;
exports.forgotPasswordDenied = forgotPasswordDenied;
var bannedStates = {
  2: 'banned',
  3: 'disapproved',
  4: 'possible spam activity',
  5: 'locked out'
};

function getResponse(err) {
  if ('response' in err || 'responseText' in err) {
    try {
      return JSON.parse(err.response || err.responseText);
    } catch (e) {
      return undefined;
    }
  } else {
    return err;
  }
}

function authDenied(err) {
  if (err.status === 401) {
    return 'signin.unauthorized';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'signin.' + bannedStates[response.data.code];
    }
    return 'signin.generic.banned';
  }
}

function forgotPasswordDenied(err) {
  if (err.status === 404) {
    return 'forgot-password.user.not-found';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'forgot-password.' + bannedStates[response.data.code];
    }
    return 'forgot-password.generic.banned';
  }
}

});
},{"8":8}],177:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMsgFromPrefix = getErrorMsgFromPrefix;
exports.getErrorClsFromPrefix = getErrorClsFromPrefix;
function getErrorMsgFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err ? err[field].msg : '';
    };
  };
}

function getErrorClsFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err && err[field].state === 'error' ? ' tes-has-error' : '';
    };
  };
}

});
},{"8":8}],178:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.careerFinder = careerFinder;
exports.filterPosition = filterPosition;
exports.getUserTypePosition = getUserTypePosition;
function careerFinder(positions, careers, currentPosition) {
  var careerMatch = careers.filter(function (item) {
    return item.name === currentPosition;
  });
  if (careerMatch.length) {
    return { name: careerMatch[0].name, groupLabel: null };
  }
  var positionMatch = positions.filter(function (item) {
    return item.name === currentPosition;
  });
  if (positionMatch.length) {
    var groupLabel = positionMatch[0].groupLabel;
    var groupMatch = careers.filter(function (item) {
      return item.groupLabel === groupLabel;
    });
    if (groupMatch.length) {
      return { name: groupMatch[0].name, groupLabel: groupLabel };
    }
  }
  return { name: '', groupLabel: null };
}

function filterPosition(positions, currentCareerObj) {
  return positions.filter(function (pos) {
    if (currentCareerObj.groupLabel) {
      return pos.groupLabel === currentCareerObj.groupLabel;
    }
    return pos.name === currentCareerObj.name;
  });
}

function getUserTypePosition(positions, currentPosition) {
  // const posObj = positions.find((pos) => pos.name === currentPosition);
  var posIndex = positions.map(function (pos) {
    return pos.name === currentPosition;
  }).indexOf(true);
  var posObj = positions[posIndex];
  return posObj ? posObj.userType : 'other';
}

});
},{"8":8}],179:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;
exports.trackError = trackError;
exports.trackForgotPassword = trackForgotPassword;
exports.trackLogin = trackLogin;
exports.trackRegister = trackRegister;
exports.getTrackingType = getTrackingType;
exports.getPageContext = getPageContext;
/* global _mz:false, _mze:false */

function hasMz() {
  try {
    return !!_mz;
  } catch (e) {
    return false;
  }
}

function trackClick(formType) {
  if (!hasMz()) return;
  var eventTitle = void 0;
  if (formType === 'sign-in') {
    eventTitle = 'login';
  } else if (formType === 'register' || formType === 'select') {
    eventTitle = 'register';
  }
  if (eventTitle) {
    _mz.emit(_mze.CLICK, {
      module: {
        type: 'auth-links'
      },
      eventTitle: eventTitle
    });
  }
}

function trackDisplay(formType, type, userType, doSelectUserType) {
  if (!hasMz()) return;
  var eventTitle = {
    'sign-in': 'tes-login',
    register: 'register',
    'forgot-password': 'forgot-password',
    select: 'tes-account-type'
  };
  var event = {
    id: eventTitle[formType] || 'tes-login',
    module: {
      id: doSelectUserType ? 'useSelect' : null,
      type: type
    }
  };

  if (formType === 'select') {
    event.variant = 'position-selector';
  } else if (userType) {
    event.variant = userType;
  }

  _mz.emit(_mze.DISPLAY, event);
}

function trackError(id, msg, type) {
  if (!hasMz()) return;
  var evt = id === 'register-fail' ? _mze.REGISTER_FAIL : _mze.LOGIN_FAIL;
  _mz.emit(evt, {
    id: id,
    payload: {
      message: msg
    },
    module: {
      type: type
    }
  });
}

function trackForgotPassword(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.SUBMIT, {
    id: 'forgot-password',
    module: {
      type: type
    }
  }, cb);
}

function trackLogin(id, type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.LOGIN, {
    id: id,
    module: {
      type: type
    }
  }, cb);
}

function trackRegister(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.REGISTER, {
    id: 'register',
    module: {
      type: type
    },
    tags: ['funnel']
  }, cb);
}

function getTrackingType(isModal, isInline) {
  if (isModal) {
    return 'modal';
  } else if (isInline) {
    return 'embed';
  }
  return 'standalone';
}

function getPageContext(pageMetadata, overridePageMetadata) {
  var meta = {};

  if ('id' in overridePageMetadata || 'id' in pageMetadata) {
    meta.pageId = overridePageMetadata.id || pageMetadata.id;
  }

  if ('type' in overridePageMetadata || 'type' in pageMetadata) {
    meta.pageType = overridePageMetadata.type || pageMetadata.type;
  }

  if ('section' in overridePageMetadata || 'section' in pageMetadata) {
    meta.pageSection = overridePageMetadata.section || pageMetadata.section;
  }

  if ('subsection' in overridePageMetadata || 'subsection' in pageMetadata) {
    meta.pageSubSection = overridePageMetadata.subsection || pageMetadata.subsection;
  }

  return meta;
}

});
},{"8":8}],180:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = traverseObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function traverseObject(obj, key) {
  if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
    return undefined;
  }
  for (var k in obj) {
    if (key === k) {
      return obj[key];
    }
    var value = traverseObject(obj[k], key);
    if (value) {
      return value;
    }
  }
  return undefined;
}

});
},{"28":28,"8":8}],181:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.initSetFormType = initSetFormType;
exports.setFormType = setFormType;
exports.setPosition = setPosition;
exports.updateUserData = updateUserData;
exports.validationErrors = validationErrors;
exports.setUserType = setUserType;
exports.successOauthSignIn = successOauthSignIn;
exports.successSignIn = successSignIn;
exports.successRegister = successRegister;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.failForgotPassword = failForgotPassword;
exports.failOauthSignIn = failOauthSignIn;
exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initOauthSignIn = initOauthSignIn;
exports.initForgotPassword = initForgotPassword;
exports.sentForgotPassword = sentForgotPassword;
exports.successForgotPassword = successForgotPassword;
exports.validateField = validateField;
exports.changeField = changeField;
exports.setField = setField;
exports.resetErrors = resetErrors;
exports.suggestUserName = suggestUserName;
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;

var _constants = require(182);

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Creators
function reset() {
  return { type: constant.RESET };
}

function initSetFormType(formType) {
  return { type: constant.INIT_SET_FORM_TYPE, formType: formType };
}

function setFormType(formType) {
  return { type: constant.SET_FORM_TYPE, formType: formType };
}

function setPosition(position, userType) {
  return { type: constant.SET_POSITION, position: position, userType: userType };
}

function updateUserData(data) {
  return { type: constant.UPDATE_USER_DATA, data: data };
}

function validationErrors(errors) {
  return { type: constant.VALIDATION_ERRORS, errors: errors };
}

function setUserType(userType) {
  return { type: constant.SET_USER_TYPE, userType: userType };
}

function successOauthSignIn() {
  return { type: constant.SUCCESS_OAUTH_SIGN_IN };
}

function successSignIn() {
  return { type: constant.SUCCESS_SIGN_IN };
}

function successRegister() {
  return { type: constant.SUCCESS_REGISTER };
}

function failSignIn(errors) {
  return { type: constant.FAIL_SIGN_IN, errors: errors };
}

function failRegister(errors) {
  return { type: constant.FAIL_REGISTER, errors: errors };
}

function failForgotPassword(errors) {
  return { type: constant.FAIL_FORGOT_PASSWORD, errors: errors };
}

function failOauthSignIn(errors) {
  return { type: constant.FAIL_OAUTH_SIGN_IN, errors: errors };
}

function initSignIn(callback) {
  return { type: constant.INIT_SIGN_IN, callback: callback };
}

function initRegister(callback) {
  return { type: constant.INIT_REGISTER, callback: callback };
}

function initOauthSignIn(provider) {
  return { type: constant.INIT_OAUTH_SIGN_IN, provider: provider };
}

function initForgotPassword() {
  return { type: constant.INIT_FORGOT_PASSWORD };
}

function sentForgotPassword() {
  return { type: constant.SENT_FORGOT_PASSWORD };
}

function successForgotPassword() {
  return { type: constant.SUCCESS_FORGOT_PASSWORD };
}

function validateField(name) {
  return { type: constant.VALIDATE_FIELD, name: name };
}

function changeField(name, deps) {
  return { type: constant.CHANGE_FIELD, name: name, deps: deps };
}

function setField(form, name, value) {
  return { type: constant.SET_FIELD, form: form, name: name, value: value };
}

function resetErrors() {
  return { type: constant.RESET_ERRORS };
}

function suggestUserName(username) {
  return { type: constant.SUGGEST_USER_NAME, username: username };
}

function trackClick(formType) {
  return { type: constant.TRACK_CLICK, formType: formType };
}

function trackDisplay(formType) {
  return { type: constant.TRACK_DISPLAY, formType: formType };
}

});
},{"182":182,"8":8}],182:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET = exports.RESET = 'RESET';
var INIT_SET_FORM_TYPE = exports.INIT_SET_FORM_TYPE = 'INIT_SET_FORM_TYPE';
var SET_FORM_TYPE = exports.SET_FORM_TYPE = 'SET_FORM_TYPE';
var SET_USER_TYPE = exports.SET_USER_TYPE = 'SET_USER_TYPE';
var SET_POSITION = exports.SET_POSITION = 'SET_POSITION';
var UPDATE_USER_DATA = exports.UPDATE_USER_DATA = 'UPDATE_USER_DATA';

var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = 'VALIDATION_ERRORS';

var SUCCESS_OAUTH_SIGN_IN = exports.SUCCESS_OAUTH_SIGN_IN = 'SUCCESS_OAUTH_SIGN_IN';
var SUCCESS_SIGN_IN = exports.SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
var SUCCESS_REGISTER = exports.SUCCESS_REGISTER = 'SUCCESS_REGISTER';
var SUCCESS_FORGOT_PASSWORD = exports.SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';

var INIT_SIGN_IN = exports.INIT_SIGN_IN = 'INIT_SIGN_IN';
var INIT_REGISTER = exports.INIT_REGISTER = 'INIT_REGISTER';
var INIT_OAUTH_SIGN_IN = exports.INIT_OAUTH_SIGN_IN = 'INIT_OAUTH_SIGN_IN';

var FAIL_SIGN_IN = exports.FAIL_SIGN_IN = 'FAIL_SIGN_IN';
var FAIL_REGISTER = exports.FAIL_REGISTER = 'FAIL_REGISTER';
var FAIL_FORGOT_PASSWORD = exports.FAIL_FORGOT_PASSWORD = 'FAIL_FORGOT_PASSWORD';
var FAIL_OAUTH_SIGN_IN = exports.FAIL_OAUTH_SIGN_IN = 'FAIL_OAUTH_SIGN_IN';

var INIT_FORGOT_PASSWORD = exports.INIT_FORGOT_PASSWORD = 'INIT_FORGOT_PASSWORD';
var SENT_FORGOT_PASSWORD = exports.SENT_FORGOT_PASSWORD = 'SENT_FORGOT_PASSWORD';

var VALIDATE_FIELD = exports.VALIDATE_FIELD = 'VALIDATE_FIELD';
var CHANGE_FIELD = exports.CHANGE_FIELD = 'CHANGE_FIELD';
var SET_FIELD = exports.SET_FIELD = 'SET_FIELD';

var RESET_ERRORS = exports.RESET_ERRORS = 'RESET_ERRORS';
var SUGGEST_USER_NAME = exports.SUGGEST_USER_NAME = 'SUGGEST_USER_NAME';

var TRACK_DISPLAY = exports.TRACK_DISPLAY = 'TRACK_DISPLAY';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

});
},{"8":8}],183:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _constants = require(182);

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  common: {},
  register: {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    newsletter: false,
    autoFillUsername: true,
    state: null
  },
  signIn: {
    identification: '',
    password: '',
    trustedComputer: false,
    state: null
  },
  forgotPassword: {
    identification: '',
    state: null
  },
  errors: {}
};

function extend(state, obj) {
  var s = {};
  (0, _keys2.default)(obj).forEach(function (attr) {
    s[attr] = (0, _assign2.default)({}, state[attr], obj[attr]);
  });
  return (0, _assign2.default)({}, state, s);
}

// Reducer
function reset(state) {
  var newState = {
    errors: {},
    common: (0, _assign2.default)({}, state.common, { oauthState: null }),
    register: initialState.register,
    signIn: initialState.signIn,
    forgotPassword: initialState.forgotPassword
  };
  newState.signIn.trustedComputer = state.common.isMobile;
  return (0, _assign2.default)({}, state, newState);
}

function resetErrors(state) {
  return (0, _assign2.default)({}, state, { errors: {} });
}

function setFormType(state, action) {
  return extend(state, { common: { formType: action.formType } });
}

function setUserType(state, action) {
  return extend(state, { common: { userType: action.userType } });
}

function setPosition(state, action) {
  return extend(state, { common: { userType: action.userType, position: action.position } });
}

function validationErrors(state, action) {
  return extend(state, { errors: action.errors });
}

function initSignIn(state) {
  return extend(resetErrors(state), { signIn: { state: 'wait' } });
}

function initRegister(state) {
  return extend(resetErrors(state), { register: { state: 'wait' } });
}

function initOauthSignIn(state, action) {
  return extend(resetErrors(state), { common: { oauthState: action.provider } });
}

function initForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'wait' } });
}

function failSignIn(state) {
  return extend(state, { signIn: { state: null } });
}

function failRegister(state) {
  return extend(state, { register: { state: null } });
}

function failOauthSignIn(state) {
  return extend(state, { common: { oauthState: null } });
}

function failForgotPassword(state) {
  return extend(state, { forgotPassword: { state: null } });
}

function sentForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'sent' } });
}

function validateField(state, action) {
  if (action.name === 'registration.email' && state.register.username === '') {
    return extend(state, { register: { autoFillUsername: true } });
  }
  if (action.name === 'registration.username') {
    return extend(state, { register: { autoFillUsername: false } });
  }
  return state;
}

function changeField(state, action) {
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors[action.name];
  action.deps.forEach(function (d) {
    return delete newErrors[d];
  });
  return (0, _assign2.default)({}, state, { errors: newErrors });
}

function setField(state, action) {
  var obj = {};
  obj[action.form] = {};
  obj[action.form][action.name] = action.value;
  if (action.form === 'signIn' && action.name === 'identification') {
    (0, _assign2.default)(obj, { forgotPassword: { identification: action.value } });
  }
  return extend(state, obj);
}

function suggestUserName(state, action) {
  if (!state.register.autoFillUsername) {
    return state;
  }
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors['registration.username'];
  var newState = (0, _assign2.default)({}, state, { errors: newErrors });
  return extend(newState, { register: { username: action.username } });
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case constant.RESET:
      return reset(state, action);
    case constant.SET_FORM_TYPE:
      return setFormType(state, action);
    case constant.SET_USER_TYPE:
      return setUserType(state, action);
    case constant.SET_POSITION:
      return setPosition(state, action);
    case constant.VALIDATION_ERRORS:
      return validationErrors(state, action);
    case constant.INIT_SIGN_IN:
      return initSignIn(state, action);
    case constant.INIT_REGISTER:
      return initRegister(state, action);
    case constant.INIT_OAUTH_SIGN_IN:
      return initOauthSignIn(state, action);
    case constant.INIT_FORGOT_PASSWORD:
      return initForgotPassword(state, action);
    case constant.FAIL_SIGN_IN:
      return failSignIn(state, action);
    case constant.FAIL_REGISTER:
      return failRegister(state, action);
    case constant.FAIL_OAUTH_SIGN_IN:
      return failOauthSignIn(state, action);
    case constant.FAIL_FORGOT_PASSWORD:
      return failForgotPassword(state, action);
    case constant.SENT_FORGOT_PASSWORD:
      return sentForgotPassword(state, action);
    case constant.VALIDATE_FIELD:
      return validateField(state, action);
    case constant.CHANGE_FIELD:
      return changeField(state, action);
    case constant.SET_FIELD:
      return setField(state, action);
    case constant.RESET_ERRORS:
      return resetErrors(state, action);
    case constant.SUGGEST_USER_NAME:
      return suggestUserName(state, action);

    default:
      return state;
  }
}

});
},{"12":12,"16":16,"182":182,"8":8}],184:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require(29);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initOauthSignIn = initOauthSignIn;
exports.initForgotPassword = initForgotPassword;
exports.successSignIn = successSignIn;
exports.successForgotPassword = successForgotPassword;
exports.updateUserData = updateUserData;
exports.validateField = validateField;
exports.suggestUserName = suggestUserName;
exports.initSetFormType = initSetFormType;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.trackClickSaga = trackClickSaga;
exports.trackDisplaySaga = trackDisplaySaga;
exports.default = rootSaga;

var _reduxSaga = require(144);

var _effects = require(142);

var _minijoi = require(139);

var _minijoi2 = _interopRequireDefault(_minijoi);

var _deniedErrorcode = require(176);

var _actions = require(181);

var actions = _interopRequireWildcard(_actions);

var _tracking = require(179);

var _traverseObject = require(180);

var _traverseObject2 = _interopRequireDefault(_traverseObject);

var _errorMessages = require(159);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _constants = require(182);

var constant = _interopRequireWildcard(_constants);

var _api = require(174);

var _api2 = _interopRequireDefault(_api);

var _utils = require(185);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initSignIn, initRegister, initOauthSignIn, initForgotPassword, successSignIn, successForgotPassword, updateUserData, validateField, suggestUserName, initSetFormType, failSignIn, failRegister, trackClickSaga, trackDisplaySaga, takeLatestWithName, rootSaga].map(_regenerator2.default.mark);

/*
  utilities
*/
function getWindow() {
  try {
    return window;
  } catch (e) {
    return {};
  }
}

function getErrorCode(xhr, prefix) {
  var genericErrorCode = xhr.status >= 400 && xhr.status < 500 ? 'denied' : 'generic';
  try {
    var response = JSON.parse(xhr.response || xhr.responseText);
    // assembling the error code
    var errorCodes = response.errors.map(function (e) {
      return prefix + '.' + e.field + '.' + e.types[0];
    });
    return errorCodes.length ? errorCodes.join(',') : prefix + '.' + genericErrorCode + '.error';
  } catch (e) {
    if (getWindow()._airbrake) {
      var errorObj = void 0;
      if (xhr.status === 0) {
        errorObj = { error: { message: 'app-authentication: api timing out (' + prefix + ') readystate ' + xhr.readyState, fileName: 'restapi.js', lineNumber: 0, columnNumber: 0 } };
      } else {
        errorObj = { error: { message: 'app-authentication: api returning unexpected ' + genericErrorCode + ' (' + prefix + '): ' + xhr.status + ' - ' + xhr.response, fileName: 'api.js', lineNumber: 0, columnNumber: 0 } };
      }
      getWindow()._airbrake.push(errorObj);
    }
    return prefix + '.' + genericErrorCode + '.error';
  }
}

var userNameValidation = _minijoi2.default.string().min(3).max(30).regex(/^[A-Za-z0-9_\-]*$/).required();
var emailValidation = _minijoi2.default.string().email();

// const schemas = {
//   registration: Joi.object().keys({
//     username: userNameValidation,
//     email: emailValidation,
//     password: Joi.string().min(6).required(),
//     firstName: Joi.string(),
//     lastName: Joi.string(),
//     newsletter: Joi.boolean(),
//   }),
// };

/*
  sagas
*/
function initSignIn(action) {
  var isInline, isModal, credentials, errorCode, errors;
  return _regenerator2.default.wrap(function initSignIn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context.sent;

          if (!(!isInline && !isModal)) {
            _context.next = 20;
            break;
          }

          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.cps)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](9);

          console.log('Tracking Login error', _context.t0.message); // eslint-disable-line no-console

        case 17:
          _context.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context.abrupt('return');

        case 20:
          _context.prev = 20;
          _context.next = 23;
          return (0, _effects.call)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context.next = 25;
          return (0, _effects.select)(_utils.getSignInData);

        case 25:
          credentials = _context.sent;
          _context.next = 28;
          return (0, _effects.call)(_api2.default.signIn, credentials);

        case 28:
          _context.next = 30;
          return (0, _effects.put)(actions.successSignIn());

        case 30:
          _context.next = 40;
          break;

        case 32:
          _context.prev = 32;
          _context.t1 = _context['catch'](20);
          errorCode = (0, _deniedErrorcode.authDenied)(_context.t1) || getErrorCode(_context.t1, 'signin');
          errors = (0, _errorMessages2.default)(errorCode);
          _context.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actions.failSignIn(errors));

        case 40:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[9, 14], [20, 32]]);
}

function initRegister(action) {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initRegister$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context2.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context2.sent;

          if (!(!isInline && !isModal)) {
            _context2.next = 20;
            break;
          }

          _context2.prev = 9;
          _context2.next = 12;
          return (0, _effects.cps)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context2.next = 17;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](9);

          console.log('Tracking Registration error', _context2.t0.message); // eslint-disable-line no-console

        case 17:
          _context2.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context2.abrupt('return');

        case 20:
          _context2.prev = 20;
          _context2.next = 23;
          return (0, _effects.call)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context2.next = 25;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 25:
          info = _context2.sent;
          _context2.next = 28;
          return (0, _effects.call)(_api2.default.register, info);

        case 28:
          _context2.next = 30;
          return (0, _effects.put)(actions.successRegister());

        case 30:
          _context2.next = 40;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t1 = _context2['catch'](20);
          errorCode = getErrorCode(_context2.t1, 'registration');
          errors = (0, _errorMessages2.default)(errorCode);
          _context2.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context2.next = 40;
          return (0, _effects.put)(actions.failRegister(errors));

        case 40:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[9, 14], [20, 32]]);
}

function initOauthSignIn(_ref) {
  var provider = _ref.provider;
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initOauthSignIn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(actions.resetErrors());

        case 3:
          _context3.next = 5;
          return (0, _effects.select)(_utils.getIsInline);

        case 5:
          isInline = _context3.sent;
          _context3.next = 8;
          return (0, _effects.select)(_utils.getIsModal);

        case 8:
          isModal = _context3.sent;
          _context3.next = 11;
          return (0, _effects.select)(_utils.getGoogleSignInData);

        case 11:
          info = _context3.sent;

          if (!(!isModal && !isInline)) {
            _context3.next = 24;
            break;
          }

          _context3.prev = 13;
          _context3.next = 16;
          return (0, _effects.cps)(_tracking.trackLogin, provider + '-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3['catch'](13);

          console.log('Tracking ' + provider + ' Login error', _context3.t0.message); // eslint-disable-line no-console

        case 21:
          _context3.next = 23;
          return (0, _effects.call)(_api2.default.oauthSignIn, provider, info);

        case 23:
          return _context3.abrupt('return');

        case 24:
          _context3.next = 26;
          return (0, _effects.call)(_tracking.trackLogin, provider + '-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 26:
          _context3.next = 28;
          return (0, _effects.call)(_api2.default.oauthSignIn, provider, info);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actions.successOauthSignIn());

        case 30:
          _context3.next = 44;
          break;

        case 32:
          _context3.prev = 32;
          _context3.t1 = _context3['catch'](0);

          if (!_context3.t1.needsPosition) {
            _context3.next = 38;
            break;
          }

          _context3.next = 37;
          return (0, _effects.put)(actions.setFormType('logged-in-select'));

        case 37:
          return _context3.abrupt('return');

        case 38:
          errorCode = _context3.t1.message;
          errors = (0, _errorMessages2.default)(errorCode);
          _context3.next = 42;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 42:
          _context3.next = 44;
          return (0, _effects.put)(actions.failOauthSignIn(errors));

        case 44:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 32], [13, 18]]);
}

function initForgotPassword() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initForgotPassword$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context4.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context4.sent;
          _context4.prev = 8;
          _context4.next = 11;
          return (0, _effects.cps)(_tracking.trackForgotPassword, (0, _tracking.getTrackingType)(isModal, isInline));

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](8);

          console.log('Tracking forgot password error', _context4.t0.message); // eslint-disable-line no-console

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.select)(_utils.getForgotPasswordData);

        case 19:
          info = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(_api2.default.forgotPassword, info);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)(actions.sentForgotPassword());

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 26:
          _context4.next = 36;
          break;

        case 28:
          _context4.prev = 28;
          _context4.t1 = _context4['catch'](16);
          errorCode = (0, _deniedErrorcode.forgotPasswordDenied)(_context4.t1) || getErrorCode(_context4.t1, 'forgot-password');
          errors = (0, _errorMessages2.default)(errorCode);
          _context4.next = 34;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 34:
          _context4.next = 36;
          return (0, _effects.put)(actions.failForgotPassword(errors));

        case 36:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[8, 13], [16, 28]]);
}

function successSignIn() {
  var onSuccess, reloadURL;
  return _regenerator2.default.wrap(function successSignIn$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_utils.getOnSuccess);

        case 2:
          onSuccess = _context5.sent;

          if (!(onSuccess === 'reload')) {
            _context5.next = 11;
            break;
          }

          _context5.next = 6;
          return (0, _effects.select)(_utils.getReloadURL);

        case 6:
          reloadURL = _context5.sent;
          _context5.next = 9;
          return (0, _effects.call)(_api2.default.reload, reloadURL);

        case 9:
          _context5.next = 19;
          break;

        case 11:
          _context5.next = 13;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 13:
          _context5.next = 15;
          return (0, _effects.call)(_api2.default.loggedInEvent);

        case 15:
          _context5.next = 17;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 17:
          _context5.next = 19;
          return (0, _effects.put)(actions.reset());

        case 19:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function successForgotPassword() {
  return _regenerator2.default.wrap(function successForgotPassword$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 2:
          _context6.next = 4;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 4:
          _context6.next = 6;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(actions.reset());

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function updateUserData(action) {
  var errorCode;
  return _regenerator2.default.wrap(function updateUserData$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_api2.default.updateUserData, action.data);

        case 3:
          _context7.next = 5;
          return (0, _effects.put)(actions.successSignIn());

        case 5:
          _context7.next = 12;
          break;

        case 7:
          _context7.prev = 7;
          _context7.t0 = _context7['catch'](0);
          errorCode = getErrorCode(_context7.t0, 'edit-account');
          _context7.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 7]]);
}

function validateField(action) {
  var userData, response, _response;

  return _regenerator2.default.wrap(function validateField$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 1200);

        case 2:
          _context8.next = 4;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 4:
          userData = _context8.sent;
          _context8.prev = 5;

          if (!(action.name === 'registration.username' && userData.username && !_minijoi2.default.validate(userData.username, userNameValidation).error)) {
            _context8.next = 15;
            break;
          }

          _context8.next = 9;
          return (0, _effects.call)(_api2.default.verifyUsername, userData.username);

        case 9:
          response = _context8.sent;

          if (!response.length) {
            _context8.next = 13;
            break;
          }

          _context8.next = 13;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.username.duplicate')));

        case 13:
          _context8.next = 25;
          break;

        case 15:
          if (!(action.name === 'registration.email' && userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context8.next = 25;
            break;
          }

          _context8.next = 18;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 18:
          _response = _context8.sent;

          if (!_response.length) {
            _context8.next = 22;
            break;
          }

          _context8.next = 22;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.email.duplicate')));

        case 22:
          if (!_response.suggestedUsername) {
            _context8.next = 25;
            break;
          }

          _context8.next = 25;
          return (0, _effects.put)(actions.suggestUserName(_response.suggestedUsername));

        case 25:
          _context8.next = 30;
          break;

        case 27:
          _context8.prev = 27;
          _context8.t0 = _context8['catch'](5);

          console.log('Error validate field', action.name, _context8.t0.message); // eslint-disable-line no-console

        case 30:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[5, 27]]);
}

function suggestUserName() {
  var userData, response;
  return _regenerator2.default.wrap(function suggestUserName$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 2:
          userData = _context9.sent;
          _context9.prev = 3;

          if (!(userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 7;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 7:
          response = _context9.sent;

          if (!response.suggestedUsername) {
            _context9.next = 11;
            break;
          }

          _context9.next = 11;
          return (0, _effects.put)(actions.suggestUserName(response.suggestedUsername));

        case 11:
          _context9.next = 16;
          break;

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9['catch'](3);

          console.log('Error suggest username', _context9.t0.message); // eslint-disable-line no-console

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[3, 13]]);
}

function initSetFormType(action) {
  var isInline, isModal, oldFormType;
  return _regenerator2.default.wrap(function initSetFormType$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context10.sent;
          _context10.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context10.sent;

          if (!(!isModal && !isInline)) {
            _context10.next = 8;
            break;
          }

          return _context10.abrupt('return');

        case 8:
          _context10.next = 10;
          return (0, _effects.select)(_utils.getFormType);

        case 10:
          oldFormType = _context10.sent;

          if (!(oldFormType === action.formType)) {
            _context10.next = 13;
            break;
          }

          return _context10.abrupt('return');

        case 13:
          _context10.next = 15;
          return (0, _effects.put)(actions.setFormType(action.formType));

        case 15:
          _context10.next = 17;
          return (0, _effects.put)(actions.trackClick(action.formType));

        case 17:
          _context10.next = 19;
          return (0, _effects.put)(actions.trackDisplay(action.formType));

        case 19:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function failSignIn(action) {
  var filteredErrors, msg, id, isInline, isModal;
  return _regenerator2.default.wrap(function failSignIn$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (action.errors) {
            _context11.next = 2;
            break;
          }

          return _context11.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('signin.') || e.startsWith('generic.googlebutton');
          });

          if (!filteredErrors.length) {
            _context11.next = 14;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          id = filteredErrors[0] === 'generic.googlebutton' ? 'google-login-fail' : 'login-fail';
          _context11.next = 8;
          return (0, _effects.select)(_utils.getIsInline);

        case 8:
          isInline = _context11.sent;
          _context11.next = 11;
          return (0, _effects.select)(_utils.getIsModal);

        case 11:
          isModal = _context11.sent;
          _context11.next = 14;
          return (0, _effects.call)(_tracking.trackError, id, msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 14:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function failRegister(action) {
  var filteredErrors, msg, isInline, isModal;
  return _regenerator2.default.wrap(function failRegister$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (action.errors) {
            _context12.next = 2;
            break;
          }

          return _context12.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('registration.');
          });

          if (!filteredErrors.length) {
            _context12.next = 13;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          _context12.next = 7;
          return (0, _effects.select)(_utils.getIsInline);

        case 7:
          isInline = _context12.sent;
          _context12.next = 10;
          return (0, _effects.select)(_utils.getIsModal);

        case 10:
          isModal = _context12.sent;
          _context12.next = 13;
          return (0, _effects.call)(_tracking.trackError, 'register-fail', msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 13:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function trackClickSaga(action) {
  return _regenerator2.default.wrap(function trackClickSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.call)(_tracking.trackClick, action.formType);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function trackDisplaySaga(action) {
  var isInline, isModal, userType, doSelectUserType;
  return _regenerator2.default.wrap(function trackDisplaySaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context14.sent;
          _context14.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context14.sent;
          _context14.next = 8;
          return (0, _effects.select)(_utils.getUserType);

        case 8:
          userType = _context14.sent;
          _context14.next = 11;
          return (0, _effects.select)(_utils.getDoSelectUserType);

        case 11:
          doSelectUserType = _context14.sent;

          if (isInline) {
            _context14.next = 15;
            break;
          }

          _context14.next = 15;
          return (0, _effects.call)(_tracking.trackDisplay, action.formType, (0, _tracking.getTrackingType)(isModal, isInline), userType, doSelectUserType);

        case 15:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function takeLatestWithName(pattern, saga) {
  var task;
  return _regenerator2.default.wrap(function takeLatestWithName$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.fork)(_regenerator2.default.mark(function newSaga() {
            var lastTask, action;
            return _regenerator2.default.wrap(function newSaga$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    lastTask = {};

                  case 1:
                    if (!true) {
                      _context15.next = 13;
                      break;
                    }

                    _context15.next = 4;
                    return (0, _effects.take)(pattern);

                  case 4:
                    action = _context15.sent;

                    if (!(action.name in lastTask)) {
                      _context15.next = 8;
                      break;
                    }

                    _context15.next = 8;
                    return (0, _effects.cancel)(lastTask[action.name]);

                  case 8:
                    _context15.next = 10;
                    return (0, _effects.fork)(saga, action);

                  case 10:
                    lastTask[action.name] = _context15.sent;
                    _context15.next = 1;
                    break;

                  case 13:
                  case 'end':
                    return _context15.stop();
                }
              }
            }, newSaga, this);
          }));

        case 2:
          task = _context16.sent;
          return _context16.abrupt('return', task);

        case 4:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[14], this);
}

function isEmail(action) {
  return action.type === constant.VALIDATE_FIELD && action.name === 'registration.email';
}

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return [(0, _reduxSaga.takeEvery)(constant.INIT_SIGN_IN, initSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_REGISTER, initRegister), (0, _reduxSaga.takeEvery)(constant.INIT_OAUTH_SIGN_IN, initOauthSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_FORGOT_PASSWORD, initForgotPassword), (0, _reduxSaga.takeEvery)(constant.SUCCESS_OAUTH_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_REGISTER, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_FORGOT_PASSWORD, successForgotPassword), (0, _reduxSaga.takeEvery)(constant.UPDATE_USER_DATA, updateUserData), (0, _reduxSaga.takeEvery)(constant.INIT_SET_FORM_TYPE, initSetFormType), (0, _reduxSaga.takeEvery)(constant.FAIL_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_OAUTH_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_REGISTER, failRegister), (0, _reduxSaga.takeEvery)(constant.TRACK_CLICK, trackClickSaga), (0, _reduxSaga.takeEvery)(constant.TRACK_DISPLAY, trackDisplaySaga), takeLatestWithName(constant.VALIDATE_FIELD, validateField), (0, _reduxSaga.throttle)(800, isEmail, suggestUserName)];

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[15], this);
}

});
},{"139":139,"142":142,"144":144,"159":159,"16":16,"174":174,"176":176,"179":179,"180":180,"181":181,"182":182,"185":185,"29":29,"8":8}],185:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReloadURL = getReloadURL;
exports.getDoSelectUserType = getDoSelectUserType;
exports.getOnSuccess = getOnSuccess;
exports.getFormType = getFormType;
exports.getIsInline = getIsInline;
exports.getIsModal = getIsModal;
exports.getUserType = getUserType;
exports.getForgotPasswordData = getForgotPasswordData;
exports.getSignInData = getSignInData;
exports.getRegistrationData = getRegistrationData;
exports.getGoogleSignInData = getGoogleSignInData;

var _tracking = require(179);

var _dateHelper = require(175);

function getReloadURL(state) {
  return state.common.reloadURL;
}

function getDoSelectUserType(state) {
  return state.common.doSelectUserType;
}

function getOnSuccess(state) {
  return state.common.onSuccess;
}

function getFormType(state) {
  return state.common.formType;
}

function getIsInline(state) {
  return state.common.isInline;
}

function getIsModal(state) {
  return state.common.isModal;
}

function getUserType(state) {
  return state.common.userType;
}

function getForgotPasswordData(state) {
  return { email: state.forgotPassword.identification };
}

function getSignInData(state) {
  var common = state.common;
  var signIn = state.signIn;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var identification = signIn.identification;
  var password = signIn.password;
  var trustedComputer = signIn.trustedComputer;
  var appId = common.appId;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    appId: appId,
    identification: identification,
    password: password,
    trustedComputer: trustedComputer,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection
  };

  return data;
}

function getRegistrationData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isModal = common.isModal;
  var isInline = common.isInline;
  var isStudent = common.userType === 'student';

  var hasDoB = !!register.dateOfBirth;
  var under13 = (0, _dateHelper.isUnder13)(register.dateOfBirth);

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    username: register.username,
    email: register.email || '',
    password: register.password,
    userType: common.userType || null,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: !isModal && !isInline ? common.rtn : window && window.location.href,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    appId: common.appId
  };

  data.position = common.position || '';

  if (!common.omitName) {
    data.firstName = register.firstName;
    data.lastName = register.lastName;
  }

  if (isStudent && hasDoB) {
    data.dateOfBirth = register.dateOfBirth;
  }

  if (isStudent && under13) {
    data.classCode = register.classCode;
    data.guardianEmail = register.guardianEmail;
  }

  return data;
}

function getGoogleSignInData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isStudent = common.userType === 'student';
  var isModal = common.isModal;
  var isInline = common.isInline;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;
  var regUrl = void 0;
  if (common.regUrl) {
    regUrl = common.regUrl;
  } else if (!isModal && !isInline) {
    regUrl = common.rtn;
  } else {
    regUrl = window && window.location.href;
  }

  var data = {
    isModal: isModal || isInline,
    userType: common.userType,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: regUrl,
    appId: common.appId,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    trustedComputer: state.signIn.trustedComputer,
    rtn: isModal || isInline ? '/oauth/close-modal' : common.rtn || window.location.href
  };

  data.position = common.position || '';

  return data;
}

});
},{"175":175,"179":179,"8":8}],186:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

require(136);

var _es6ObjectAssign = require(131);

var _es6ObjectAssign2 = _interopRequireDefault(_es6ObjectAssign);

require(158);

var _reduxSaga = require(144);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactDom = __react_dom;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __react_redux;

var _redux = __redux;

var _reducers = require(183);

var _reducers2 = _interopRequireDefault(_reducers);

var _App = require(160);

var _App2 = _interopRequireDefault(_App);

var _sagas = require(184);

var _sagas2 = _interopRequireDefault(_sagas);

var _actions = require(181);

var actions = _interopRequireWildcard(_actions);

var _utils = require(185);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = window.TES.events; // polyfills


_es6ObjectAssign2.default.polyfill();

var mountPointCls = 'app-auth-mountpoint';
var mountPoint = '.' + mountPointCls;

var bootstrap = function bootstrap() {
  var sagaMiddleware = (0, _reduxSaga2.default)();

  var mountElement = document.querySelector(mountPoint);
  mountElement.className = mountPointCls + '-loaded';
  var initialState = JSON.parse(mountElement.getAttribute('data-init-state'));

  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware));

  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
  // then run the saga
  sagaMiddleware.run(_sagas2.default);

  var app = _react2.default.createElement(_App2.default);
  var provider = _react2.default.createElement(_reactRedux.Provider, { store: store }, app);

  _reactDom2.default.render(provider, mountElement);

  events.on('modal-switch', function (eventType, data) {
    if (data.appId === 'authapp') {
      store.dispatch(actions.initSetFormType(data.msg));
    }
  });
  // // this sends an event only when I am NOT changing the form type
  events.on(/modal-(switch|init)/, function (eventType, data) {
    var form = data.msg;
    if (data.appId === 'authapp' && form === (0, _utils.getFormType)(store.getState())) {
      store.dispatch(actions.trackClick(form));
    }
  });
};

if (document.querySelector(mountPoint)) {
  bootstrap(); // page init
} else {
  events.one('modal-init', bootstrap); // modal init
}

});
},{"131":131,"136":136,"144":144,"158":158,"160":160,"181":181,"183":183,"184":184,"185":185,"8":8}]},{},[186])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
